// import { useState, useEffect, useRef } from "react";
// import {
//   Clock,
//   CheckCircle,
//   AlertCircle,
//   Package,
//   MapPin,
//   Phone,
//   User,
//   CreditCard,
//   Store,
//   ArrowRight,
//   X,
//   Image,
//   FileCheck,
//   Smartphone,
//   QrCode,
//   Plus,
//   ChevronDown,
//   Navigation,
//   Search,
//   Tag,
// } from "lucide-react";
// import "./CheckoutPage.scss";
// import { getLanguage } from "../../utils/Helper";
// import { useNavigate, useLocation } from "react-router-dom";
// import { useAuth } from "../../context/AuthContext";
// import { useCart } from "../../context/CartContext";
// import { toast } from "react-toastify";
// import { fetchUserAddresses } from "../../services/UsersApiService";
// import OrderApiService from "../../services/OrderApiService";
// import { HttpStatusCode } from "axios";
// import { egyptGovernorates, getGovernorateName } from "../../utils/Helper";
// import { compressImage } from "../../utils/imageCompressor";

// const CheckoutPage = () => {
//   const navigate = useNavigate();
//   const location = useLocation();
//   const authContext = useAuth();

//   const checkoutSession = location.state || {};
//   const { checkoutId, expiresAt, expiresIn } = checkoutSession;

//   useEffect(() => {
//     if (!checkoutId) {
//       const lang = getLanguage();
//       toast.error(
//         lang === "AR"
//           ? // ? "لا توجد جلسة دفع صالحة. من فضلك ابدأ من السلة."
//             // : "No valid checkout session. Please start from cart.",
//             "يجب ان تبدأ من السلة"
//           : "Start checkout from your cart",
//       );
//       navigate("/");
//     }
//   }, [checkoutId, navigate]);

//   const getInitialTimeLeft = () => {
//     if (expiresIn) return expiresIn;
//     if (expiresAt) {
//       const expiryDate = new Date(expiresAt);
//       const now = new Date();
//       const secondsLeft = Math.floor((expiryDate - now) / 1000);
//       return Math.max(0, secondsLeft);
//     }
//     return 300;
//   };

//   const [timeLeft, setTimeLeft] = useState(getInitialTimeLeft());
//   const [isExpired, setIsExpired] = useState(false);
//   const [step, setStep] = useState(1);
//   const [uploadedImage, setUploadedImage] = useState(null);
//   const [imagePreview, setImagePreview] = useState(null);
//   const [isSubmitting, setIsSubmitting] = useState(false);
//   const [showSuccess, setShowSuccess] = useState(false);
//   const fileInputRef = useRef(null);
//   const lang = getLanguage();

//   const [savedAddresses, setSavedAddresses] = useState([]);
//   const [isLoadingAddresses, setIsLoadingAddresses] = useState(false);
//   const [selectedAddressId, setSelectedAddressId] = useState(null);
//   const [useNewAddress, setUseNewAddress] = useState(false);
//   const [deliveryType, setDeliveryType] = useState("delivery");
//   const [selectedBranch, setSelectedBranch] = useState(null);

//   // Leaflet Maps States
//   const [selectedLocation, setSelectedLocation] = useState({
//     lat: 30.0444,
//     lng: 31.2357,
//   });
//   const [searchQuery, setSearchQuery] = useState("");
//   const [isSearching, setIsSearching] = useState(false);
//   const [mapInitialized, setMapInitialized] = useState(false);
//   const markerRef = useRef(null);
//   const leafletMapRef = useRef(null);

//   // Promo Code States
//   const [promoCode, setPromoCode] = useState("");
//   const [appliedPromo, setAppliedPromo] = useState(null);
//   const [isApplyingPromo, setIsApplyingPromo] = useState(false);
//   const [promoError, setPromoError] = useState("");
//   const [promoSuccess, setPromoSuccess] = useState("");
//   const [discountAmount, setDiscountAmount] = useState(0);

//   const [formData, setFormData] = useState({
//     fullName: "",
//     phone: "",
//     email: "",
//     address: "",
//     city: "",
//     state: "",
//     notes: "",
//     paymentMethod: "INSTAPAY",
//     latitude: null,
//     longitude: null,
//   });

//   const [errors, setErrors] = useState({});

//   const { cartItems, subtotal, shipping, total, clearCart } = useCart();

//   useEffect(() => {
//     if (lang === "EN") {
//       governoratesList.map((gov) => {
//         if (gov.nameAr === formData.state) {
//           setFormData((prev) => ({ ...prev, state: gov.nameEn }));
//         }
//       });
//     }
//   }, [selectedLocation]);

//   const branches = [
//     {
//       id: 1,
//       name: { EN: "Al-Mokatam Branch", AR: "فرع المقطم" },
//       address: {
//         EN: "Al-Mokatam, Middle Hills, Modern University Street, next to Shahpur Pharmacy",
//         AR: "المقطم الهضبة الوسطي، شارع الجامعة الحديثة بجوار صيدلية شاهبور",
//       },
//       phone: "01006611664",
//       hours: { EN: "Daily: 9 AM - 2 PM", AR: "يومياً: 9 صباحاً - 2 مساءً" },
//     },
//   ];

//   const governoratesList = egyptGovernorates.map((gov) => ({
//     id: gov.id,
//     nameEn: getGovernorateName("EN", gov),
//     nameAr: getGovernorateName("AR", gov),
//   }));

//   const content = {
//     EN: {
//       timer: {
//         label: "Time Remaining:",
//         expired: "Time's Up",
//         expiredMsg:
//           "Sorry, your reservation time has expired. Please return to cart and try again.",
//         retry: "Back to Home",
//       },
//       summary: {
//         title: "Order Summary",
//         subtotal: "Subtotal",
//         shipping: "Shipping",
//         free: "Free",
//         total: "Total",
//         // depositLabel: "Amount Due Now",
//         // depositDesc: "of the total, and the remainder upon delivery.",
//         depositLabel: "Total Amount to Transfer",
//         kdepositDesc: "full payment required",
//         promo: "Promo Code",
//         promoPlaceholder: "Enter promo code",
//         apply: "Apply",
//         applied: "Promo applied:",
//         remove: "Remove",
//         discount: "Discount",
//       },
//       steps: {
//         info: "Information",
//         payment: "Payment",
//         confirm: "Confirmation",
//       },
//       deliveryOptions: {
//         title: "Delivery Method",
//         delivery: {
//           title: "Home Delivery",
//           desc: "Get your order delivered to your address",
//         },
//         pickup: {
//           title: "Store Pickup",
//           desc: "Pick up your order from our branch",
//         },
//       },
//       step1: {
//         title: "Shipping Information",
//         savedAddresses: "Saved Addresses",
//         selectAddress: "Select an address",
//         useNewAddress: "Use a new address",
//         fullName: "Full Name *",
//         fullNamePlaceholder: "Enter your full name",
//         phone: "Phone Number *",
//         phonePlaceholder: "01xxxxxxxxx",
//         email: "Email *",
//         emailPlaceholder: "your@email.com",
//         city: "City *",
//         cityPlaceholder: "Maadi, Mokatam...",
//         state: "Governorate *",
//         selectState: "Select governorate",
//         address: "Detailed Address *",
//         addressPlaceholder: "Street, area, building number, floor...",
//         notes: "Notes (Optional)",
//         notesPlaceholder: "Any additional notes or instructions...",
//         nextBtn: "Next: Payment Method",
//         required: "Required field",
//         loadingAddresses: "Loading addresses...",
//         mapTitle: "Select Location on Map",
//         mapInstruction: "Click or drag the pin to your exact location",
//         currentLocation: "My Location",
//         search: "Search for address...",
//         searchBtn: "Search",
//       },
//       branches: {
//         title: "Select Branch",
//         selectBranch: "Choose pickup branch",
//         selectBranchError: "Please select a branch",
//       },
//       step2: {
//         title: "Payment Method",
//         cash: {
//           name: "Cash on Delivery",
//           desc: "Pay when you receive your order",
//         },
//         instapay: { name: "InstaPay", desc: "Instant transfer" },
//         wallet: {
//           name: "Digital Wallet",
//           desc: "Orange/Vodafone/Etislat/WE wallet",
//         },
//         instructionsTitle: "Payment Instructions",
//         instruction1: "Transfer",
//         instruction1b: "EGP to the following number:",
//         instruction2: "Keep the transfer receipt (Screenshot)",
//         instruction3: "Upload the receipt image in the next step",
//         instruction4: "Your order will be reviewed within 24 hours",
//         // instruction5: "Remaining amount paid on delivery",
//         instruction5: "Full payment required via transfer",
//         instructionPickup1: "Transfer full amount before pickup",
//         instructionPickup2: "Keep the transfer receipt (Screenshot)",
//         instructionPickup3: "Upload the receipt image in the next step",
//         instructionPickup4: "We'll contact you when order is ready",
//         instructionPickup5: "Present your receipt when collecting your order",

//         instaPayNumber: "01678900000",
//         walletNumber: "01006611664",
//         instaPayLink: "Transfer via InstaPay Link",
//         instaPayLinkDesc: "Click to open InstaPay app directly",
//         orText: "Or",
//         transferManually: "Transfer manually to:",

//         note: "Important Note:",
//         noteText: "After completing the transfer, you have",
//         noteText2: "to complete the order before reservation cancellation",
//         notePickup: "You can proceed directly to confirmation",
//         backBtn: "Back",
//         nextBtn: "Next: Upload Receipt",
//         nextBtnPickup: "Next: Upload Receipt",
//       },
//       step3: {
//         title: "Upload Payment Receipt",
//         titlePickup: "Final Review & Confirmation",
//         uploadTitle: "Click to upload receipt image",
//         uploadDesc: "PNG, JPG or JPEG (Max 5MB)",
//         uploadOptional: "(Optional for pickup orders)",
//         reviewTitle: "Final Review",
//         name: "Name:",
//         phone: "Phone:",
//         email: "Email:",
//         city: "City:",
//         state: "Governorate:",
//         address: "Address:",
//         paymentMethod: "Payment Method:",
//         amountPaid: "Amount Paid:",
//         deliveryType: "Delivery Method:",
//         branch: "Pickup Branch:",
//         backBtn: "Back",
//         submitBtn: "Confirm & Complete Order",
//         submitting: "Processing order...",
//       },
//       success: {
//         title: "Order Submitted Successfully!",
//         message: "Your order will be reviewed and we'll contact you soon",
//       },
//       errors: {
//         nameRequired: "Name is required",
//         phoneRequired: "Phone number is required",
//         emailRequired: "Email is required",
//         addressRequired: "Address is required",
//         cityRequired: "City is required",
//         stateRequired: "Governorate is required",
//         imageRequired: "Please upload transfer receipt first",
//         imageSize: "Image size is too large! Maximum 5MB",
//         promoInvalid: "Invalid promo code",
//         promoApplied: "Promo code applied successfully!",
//       },
//       emptyCart: "Your cart is empty",
//       emptyCartMsg: "Please add items to cart first",
//       goToShop: "Go to Shop",
//       color: "Color",
//       size: "Size",
//       withoutBox: "Without Box",
//       qty: "Qty",
//       default: "Default",
//     },
//     AR: {
//       timer: {
//         label: "الوقت المتبقي:",
//         expired: "انتهى الوقت المخصص",
//         expiredMsg:
//           "عذراً، انتهت مدة الحجز للمنتجات. من فضلك ارجع للسلة وأعد المحاولة.",
//         retry: "العودة للرئيسية",
//       },
//       summary: {
//         title: "ملخص الطلب",
//         subtotal: "المجموع الفرعي",
//         shipping: "الشحن",
//         free: "مجاناً",
//         total: "الإجمالي",
//         // depositLabel: "المبلغ المطلوب الآن",
//         // depositDesc: "من الإجمالي و الباقي عند الإستلام",
//         depositLabel: "المبلغ الإجمالي المطلوب تحويله",
//         depositDesc: "يجب دفع المبلغ كاملاً",
//         promo: "كود الخصم",
//         promoPlaceholder: "أدخل كود الخصم",
//         apply: "تطبيق",
//         applied: "تم تطبيق الكود:",
//         remove: "إزالة",
//         discount: "الخصم",
//       },
//       steps: { info: "البيانات", payment: "الدفع", confirm: "التأكيد" },
//       deliveryOptions: {
//         title: "طريقة التوصيل",
//         delivery: { title: "توصيل للمنزل", desc: "احصل على طلبك في عنوانك" },
//         pickup: { title: "استلام من الفرع", desc: "استلم طلبك من أقرب فرع" },
//       },
//       step1: {
//         title: "معلومات التوصيل",
//         savedAddresses: "العناوين المحفوظة",
//         selectAddress: "اختر عنواناً",
//         useNewAddress: "استخدام عنوان جديد",
//         fullName: "الاسم الكامل *",
//         fullNamePlaceholder: "أدخل اسمك الكامل",
//         phone: "رقم الهاتف *",
//         phonePlaceholder: "01xxxxxxxxx",
//         email: "البريد الإلكتروني *",
//         emailPlaceholder: "your@email.com",
//         city: "المدينة *",
//         cityPlaceholder: "المعادي, المقطم، ...",
//         state: "المحافظة *",
//         selectState: "اختر المحافظة",
//         address: "العنوان بالتفصيل *",
//         addressPlaceholder: "الشارع، المنطقة، رقم المبنى، الدور...",
//         notes: "ملاحظات (اختياري)",
//         notesPlaceholder: "أي ملاحظات أو تعليمات إضافية...",
//         nextBtn: "التالي: طريقة الدفع",
//         required: "حقل مطلوب",
//         loadingAddresses: "جاري تحميل العناوين...",
//         mapTitle: "حدد موقعك على الخريطة",
//         mapInstruction: "اضغط أو اسحب الدبوس لموقعك بالضبط",
//         currentLocation: "موقعي الحالي",
//         search: "ابحث عن عنوان...",
//         searchBtn: "بحث",
//       },
//       branches: {
//         title: "اختر الفرع",
//         selectBranch: "اختر فرع الاستلام",
//         selectBranchError: "برجاء اختيار فرع الاستلام",
//       },
//       step2: {
//         title: "طريقة الدفع",
//         cash: { name: "الدفع عند الاستلام", desc: "ادفع عند استلام طلبك" },

//         instapay: { name: "InstaPay", desc: "التحويل الفوري" },
//         wallet: {
//           name: "Digital Wallet",
//           desc: "محفظة أورانج/فودافون/إتصالات/وي",
//         },
//         instructionsTitle: "تعليمات الدفع",
//         instruction1: "قم بتحويل مبلغ",
//         instruction1b: "جنيه إلى الرقم التالي:",
//         instruction2: "احتفظ بإيصال التحويل (Screenshot)",
//         instruction3: "قم برفع صورة الإيصال في الخطوة التالية",
//         instruction4: "سيتم مراجعة طلبك خلال 24 ساعة",
//         // instruction5: "المبلغ المتبقي يتم دفعه عند الاستلام",
//         instruction5: "يجب دفع المبلغ كاملاً عن طريق التحويل",
//         instructionPickup1: "قم بتحويل المبلغ كاملاً قبل الاستلام",
//         instructionPickup2: "احتفظ بإيصال التحويل (Screenshot)",
//         instructionPickup3: "قم برفع صورة الإيصال في الخطوة التالية",
//         instructionPickup4: "سنتواصل معك عندما يكون الطلب جاهزاً",
//         instructionPickup5: "قدم إيصال التحويل عند استلام الطلب",
//         instaPayNumber: "01678900000",
//         walletNumber: "01006611664",
//         instaPayLink: "التحويل عبر رابط InstaPay",
//         instaPayLinkDesc: "اضغط لفتح تطبيق InstaPay مباشرة",
//         orText: "أو",
//         transferManually: "حول يدوياً إلى:",
//         note: "ملحوظة مهمة:",
//         noteText: "بعد إتمام التحويل، لديك",
//         noteText2: "لإكمال الطلب قبل إلغاء الحجز",
//         notePickup: "يمكنك المتابعة مباشرة للتأكيد",
//         backBtn: "رجوع",
//         nextBtn: "التالي: رفع الإيصال",
//         nextBtnPickup: "التالي: رفع الإيصال",
//       },
//       step3: {
//         title: "رفع إيصال التحويل",
//         titlePickup: "المراجعة النهائية والتأكيد",
//         uploadTitle: "اضغط لرفع صورة الإيصال",
//         uploadDesc: "PNG, JPG أو JPEG (حد أقصى 5MB)",
//         uploadOptional: "(اختياري لطلبات الاستلام من الفرع)",
//         reviewTitle: "مراجعة نهائية",
//         name: "الاسم:",
//         phone: "الهاتف:",
//         email: "البريد الإلكتروني:",
//         city: "المدينة:",
//         state: "المحافظة:",
//         address: "العنوان:",
//         paymentMethod: "طريقة الدفع:",
//         amountPaid: "المبلغ المدفوع:",
//         deliveryType: "طريقة التوصيل:",
//         branch: "فرع الاستلام:",
//         backBtn: "رجوع",
//         submitBtn: "تأكيد وإتمام الطلب",
//         submitting: "جاري إتمام الطلب...",
//       },
//       success: {
//         title: "تم إرسال طلبك بنجاح!",
//         message: "سيتم مراجعة طلبك والتواصل معك قريباً",
//       },
//       errors: {
//         nameRequired: "الاسم مطلوب",
//         phoneRequired: "رقم الهاتف مطلوب",
//         emailRequired: "البريد الإلكتروني مطلوب",
//         addressRequired: "العنوان مطلوب",
//         cityRequired: "المدينة مطلوبة",
//         stateRequired: "المحافظة مطلوبة",
//         imageRequired: "من فضلك ارفع صورة التحويل أولاً",
//         imageSize: "حجم الصورة كبير جداً! الحد الأقصى 5MB",
//         promoInvalid: "كود الخصم غير صالح",
//         promoApplied: "تم تطبيق كود الخصم بنجاح!",
//       },
//       emptyCart: "عربة التسوق فارغة",
//       emptyCartMsg: "من فضلك أضف منتجات للسلة أولاً",
//       goToShop: "الذهاب للمتجر",
//       color: "اللون",
//       size: "المقاس",
//       withoutBox: "بدون علبة",
//       qty: "الكمية",
//       default: "افتراضي",
//     },
//   };

//   const t = content[lang] || content.EN;

//   // // Load Leaflet CSS and JS
//   // useEffect(() => {
//   //   // Load Leaflet CSS
//   //   if (!document.querySelector('link[href*="leaflet.css"]')) {
//   //     const link = document.createElement('link');
//   //     link.rel = 'stylesheet';
//   //     link.href = 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.9.4/leaflet.css';
//   //     document.head.appendChild(link);
//   //   }

//   //   // Load Leaflet JS
//   //   if (!window.L && !document.querySelector('script[src*="leaflet.js"]')) {
//   //     const script = document.createElement('script');
//   //     script.src = 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.9.4/leaflet.js';
//   //     script.onload = () => {
//   //       // Map will be initialized when step 1 and delivery type is 'delivery'
//   //       // AND (user not logged in OR user chooses new address)
//   //       if (step === 1 && deliveryType === 'delivery' && (useNewAddress || !authContext?.user)) {
//   //         setTimeout(initializeMap, 100);
//   //       }
//   //     };
//   //     document.body.appendChild(script);
//   //   }

//   //   return () => {
//   //     // Cleanup map when component unmounts
//   //     if (leafletMapRef.current) {
//   //       leafletMapRef.current.remove();
//   //       leafletMapRef.current = null;
//   //       setMapInitialized(false);
//   //     }
//   //   };
//   // }, []);

//   // Initialize map when step changes to 1 and delivery type is 'delivery'
//   // AND (user not logged in OR user chooses new address)
//   useEffect(() => {
//     if (
//       step === 1 &&
//       deliveryType === "delivery" &&
//       window.L &&
//       !mapInitialized
//     ) {
//       // Show map if: user not logged in OR user chooses new address
//       if (!authContext?.user || useNewAddress) {
//         setTimeout(initializeMap, 100);
//       }
//     }
//   }, [step, deliveryType, mapInitialized, authContext?.user, useNewAddress]);

//   // Initialize Leaflet Map
//   const initializeMap = () => {
//     if (!window.L || mapInitialized) return;

//     const mapElement = document.getElementById("inline-leaflet-map");
//     if (!mapElement) return;

//     // Clear previous map instance
//     if (leafletMapRef.current) {
//       leafletMapRef.current.remove();
//       leafletMapRef.current = null;
//     }

//     // Initialize map with dark theme
//     const map = window.L.map("inline-leaflet-map", {
//       center: [selectedLocation.lat, selectedLocation.lng],
//       zoom: 15,
//       zoomControl: true,
//     });

//     // Add dark theme tiles
//     window.L.tileLayer(
//       "https://{s}.basemaps.cartocdn.com/dark_all/{z}/{x}/{y}{r}.png",
//       {
//         attribution: "©OpenStreetMap, ©CartoDB",
//         maxZoom: 19,
//         subdomains: "abcd",
//       },
//     ).addTo(map);

//     // Custom marker icon (gold pin)
//     const goldIcon = window.L.divIcon({
//       className: "custom-leaflet-marker",
//       html: `<div style="
//         width: 40px;
//         height: 40px;
//         background: linear-gradient(135deg, #f6d365 0%, #fda085 100%);
//         border-radius: 50% 50% 50% 0;
//         transform: rotate(-45deg);
//         border: 3px solid white;
//         box-shadow: 0 8px 24px rgba(246, 211, 101, 0.6);
//         position: relative;
//       ">
//         <div style="
//           position: absolute;
//           top: 50%;
//           left: 50%;
//           transform: translate(-50%, -50%) rotate(45deg);
//           font-size: 20px;
//         ">📍</div>
//       </div>`,
//       iconSize: [40, 40],
//       iconAnchor: [20, 40],
//     });

//     const marker = window.L.marker(
//       [selectedLocation.lat, selectedLocation.lng],
//       {
//         icon: goldIcon,
//         draggable: true,
//       },
//     ).addTo(map);

//     markerRef.current = marker;
//     leafletMapRef.current = map;
//     setMapInitialized(true);

//     // Marker drag event
//     marker.on("dragend", () => {
//       const position = marker.getLatLng();
//       reverseGeocode(position.lat, position.lng);
//     });

//     // Map click event
//     map.on("click", (e) => {
//       marker.setLatLng(e.latlng);
//       reverseGeocode(e.latlng.lat, e.latlng.lng);
//     });

//     // Initial reverse geocode
//     reverseGeocode(selectedLocation.lat, selectedLocation.lng);
//   };

//   // Reverse Geocode using Nominatim (Free)
//   const reverseGeocode = async (lat, lng) => {
//     try {
//       const response = await fetch(
//         `https://nominatim.openstreetmap.org/reverse?format=json&lat=${lat}&lon=${lng}&accept-language=${lang === "ar"}`,
//       );
//       const data = await response.json();

//       if (data && data.address) {
//         const city =
//           data.address.city || data.address.town || data.address.village || "";
//         const state = data.address.state || "";
//         const street = data.display_name || "";

//         setSelectedLocation({ lat, lng });
//         setFormData((prev) => ({
//           ...prev,
//           address: street,
//           city: city || prev.city,
//           state: state || prev.state,
//           latitude: lat,
//           longitude: lng,
//         }));
//       }
//     } catch (error) {
//       console.error("Reverse geocoding error:", error);
//     }
//   };

//   // Get Current Location
//   const getCurrentLocation = () => {
//     if (!navigator.geolocation) {
//       toast.error(
//         lang === "AR"
//           ? "المتصفح لا يدعم تحديد الموقع"
//           : "Geolocation is not supported",
//       );
//       return;
//     }

//     toast.info(t.step1.currentLocation + "...");

//     navigator.geolocation.getCurrentPosition(
//       (position) => {
//         const { latitude, longitude } = position.coords;
//         setSelectedLocation({ lat: latitude, lng: longitude });

//         if (leafletMapRef.current && markerRef.current) {
//           const newPos = [latitude, longitude];
//           leafletMapRef.current.setView(newPos, 17);
//           markerRef.current.setLatLng(newPos);
//           reverseGeocode(latitude, longitude);
//         }
//         toast.success(
//           lang === "AR" ? "✅ تم تحديد موقعك" : "✅ Location detected",
//         );
//       },
//       (error) => {
//         console.error("Geolocation error:", error);
//         toast.error(
//           lang === "AR" ? "فشل تحديد موقعك" : "Failed to get your location",
//         );
//       },
//     );
//   };

//   // Search for Address
//   const handleMapSearch = async () => {
//     if (!searchQuery.trim()) return;

//     setIsSearching(true);
//     try {
//       const response = await fetch(
//         `https://nominatim.openstreetmap.org/search?format=json&q=${encodeURIComponent(searchQuery)}&limit=1&accept-language=${lang === "AR" ? "ar" : "en"}&countrycodes=eg`,
//       );
//       const data = await response.json();

//       if (data && data[0]) {
//         const { lat, lon } = data[0];
//         const newLat = parseFloat(lat);
//         const newLng = parseFloat(lon);

//         setSelectedLocation({ lat: newLat, lng: newLng });

//         if (leafletMapRef.current && markerRef.current) {
//           leafletMapRef.current.setView([newLat, newLng], 17);
//           markerRef.current.setLatLng([newLat, newLng]);
//           reverseGeocode(newLat, newLng);
//         }
//         toast.success(
//           lang === "AR" ? "تم العثور على الموقع" : "Location found",
//         );
//       } else {
//         toast.error(
//           lang === "AR" ? "لم يتم العثور على الموقع" : "Location not found",
//         );
//       }
//     } catch (error) {
//       console.error("Search error:", error);
//       toast.error(lang === "AR" ? "خطأ في البحث" : "Search error");
//     } finally {
//       setIsSearching(false);
//     }
//   };

//   useEffect(() => {
//     const fetchAddresses = async () => {
//       if (!authContext?.user?.id) {
//         // User not logged in - show map immediately
//         if (deliveryType === "delivery") {
//           setUseNewAddress(true);
//         }
//         return;
//       }

//       try {
//         setIsLoadingAddresses(true);
//         const response = await fetchUserAddresses(authContext.user.id);

//         if (response.status === HttpStatusCode.Ok) {
//           setSavedAddresses(response.data || []);

//           const defaultAddress = response.data.find((addr) => addr.isDefault);
//           if (defaultAddress) {
//             setSelectedAddressId(defaultAddress.id);
//             fillFormWithAddress(defaultAddress);
//           } else if (response.data.length > 0) {
//             setSelectedAddressId(response.data[0].id);
//             fillFormWithAddress(response.data[0]);
//           } else {
//             setUseNewAddress(true);
//           }
//         }
//       } catch (error) {
//         console.error("Error fetching addresses:", error);
//         setUseNewAddress(true);
//       } finally {
//         setIsLoadingAddresses(false);
//       }
//     };

//     fetchAddresses();
//   }, [authContext?.user?.id]);

//   const fillFormWithAddress = (address) => {
//     setFormData((prev) => ({
//       ...prev,
//       fullName:
//         `${authContext.user?.firstName || ""} ${authContext.user?.lastName || ""}`.trim(),
//       phone: address.phoneNumber || authContext.user?.mobile || "",
//       email: authContext.user?.email || "",
//       address: address.street || "",
//       city: address.city || "",
//       state: address.state || "",
//     }));
//   };

//   const handleAddressSelect = (addressId) => {
//     setSelectedAddressId(addressId);
//     setUseNewAddress(false);

//     const selectedAddress = savedAddresses.find(
//       (addr) => addr.id === addressId,
//     );
//     if (selectedAddress) {
//       fillFormWithAddress(selectedAddress);
//     }
//   };

//   const handleUseNewAddress = () => {
//     setUseNewAddress(true);
//     setSelectedAddressId(null);
//     setFormData((prev) => ({
//       ...prev,
//       fullName:
//         `${authContext.user?.firstName || ""} ${authContext.user?.lastName || ""}`.trim(),
//       phone: authContext.user?.mobile || "",
//       email: authContext.user?.email || "",
//       address: "",
//       city: "",
//       state: "",
//     }));

//     // Initialize map when user chooses new address
//     if (deliveryType === "delivery" && window.L && !mapInitialized) {
//       setTimeout(initializeMap, 100);
//     }
//   };

//   const handleDeliveryTypeChange = (type) => {
//     setDeliveryType(type);
//     if (type === "pickup") {
//       setFormData((prev) => ({
//         ...prev,
//         address: "",
//         city: "",
//         state: "",
//         paymentMethod: "INSTAPAY",
//       }));
//       // Cleanup map when switching to pickup
//       if (leafletMapRef.current) {
//         leafletMapRef.current.remove();
//         leafletMapRef.current = null;
//         setMapInitialized(false);
//       }
//     } else if (type === "delivery") {
//       setFormData((prev) => ({
//         ...prev,
//         paymentMethod: "INSTAPAY",
//       }));

//       const selectedAddress = savedAddresses.find(
//         (addr) => addr.id === selectedAddressId,
//       );
//       if (selectedAddress) {
//         fillFormWithAddress(selectedAddress);
//       }
//       // Initialize map when switching to delivery AND (user not logged in OR uses new address)
//       if (
//         window.L &&
//         !mapInitialized &&
//         (!authContext?.user || useNewAddress)
//       ) {
//         setTimeout(initializeMap, 100);
//       }
//     }
//   };

//   const handleBranchSelect = (branch) => {
//     setSelectedBranch(branch);
//   };

//   // Apply Promo Code
//   const handleApplyPromo = async () => {
//     if (!promoCode.trim()) {
//       setPromoError(
//         lang === "AR" ? "من فضلك أدخل كود الخصم" : "Please enter a promo code",
//       );
//       return;
//     }

//     setIsApplyingPromo(true);
//     setPromoError("");
//     setPromoSuccess("");

//     try {
//       // Static validation for now - you'll connect this to backend later
//       const response = await OrderApiService.validatePromoCode(
//         promoCode.trim(),
//         total,
//       );
//       if (response.status !== HttpStatusCode.Ok) {
//         if (!response.isValid) {
//           // setPromoError(t.errors.promoInvalid);
//           // Minimum order amount required:
//           if (response.message.includes("Minimum order amount required")) {
//             const minAmount = response.message.split(":")[1].trim();
//             setPromoError(
//               lang === "AR"
//                 ? `الحد الأدنى للطلب لتطبيق هذا الكود هو ${minAmount} ج.م`
//                 : `Minimum order amount to apply this code is EGP ${minAmount}`,
//             );
//           } else {
//             setPromoError(response.message);
//           }
//           return;
//         }
//       }

//       setDiscountAmount(response.discountAmount);
//       setAppliedPromo(promoCode.toUpperCase());
//       setPromoSuccess(t.errors.promoApplied);

//       // const validPromoCodes = ['SAVE10', 'WELCOME20', 'SUMMER15'];
//       // if (validPromoCodes.includes(promoCode.toUpperCase())) {
//       //   // Calculate discount based on promo code
//       //   let discount = 0;
//       //   switch(promoCode.toUpperCase()) {
//       //     case 'SAVE10':
//       //       discount = total * 0.1; // 10% discount
//       //       break;
//       //     case 'WELCOME20':
//       //       discount = total * 0.2; // 20% discount
//       //       break;
//       //     case 'SUMMER15':
//       //       discount = total * 0.15; // 15% discount
//       //       break;
//       //     default:
//       //       discount = 0;
//       //   }

//       //   setDiscountAmount(discount);
//       //   setAppliedPromo(promoCode.toUpperCase());
//       //   setPromoSuccess(t.errors.promoApplied);
//       // } else {
//       //   setPromoError(t.errors.promoInvalid);
//       // }
//     } catch (error) {
//       console.error("Error applying promo:", error);
//       setPromoError(
//         lang === "AR" ? "خطأ في تطبيق الكود" : "Error applying promo code",
//       );
//       toast.error(
//         lang === "AR"
//           ? "❌ حدث خطأ أثناء تطبيق الكود"
//           : "❌ Error applying promo code",
//       );
//     } finally {
//       setIsApplyingPromo(false);
//     }
//   };

//   // Remove Promo Code
//   const handleRemovePromo = () => {
//     setAppliedPromo(null);
//     setPromoCode("");
//     setDiscountAmount(0);
//     setPromoError("");
//     setPromoSuccess("");
//     toast.info(lang === "AR" ? "تم إزالة كود الخصم" : "Promo code removed");
//   };

//   useEffect(() => {
//     const timer = setInterval(() => {
//       if (timeLeft <= 0) {
//         setIsExpired(true);
//         return;
//       }
//       setTimeLeft((prev) => prev - 1);
//     }, 1000);
//     return () => clearInterval(timer);
//   }, [timeLeft]);

//   const formatTime = (seconds) => {
//     const mins = Math.floor(seconds / 60);
//     const secs = seconds % 60;
//     return `${mins.toString().padStart(2, "0")}:${secs.toString().padStart(2, "0")}`;
//   };

//   // const depositAmount = Math.max(shipping, (total - discountAmount) * 0.1);
//   // const depositPercentage =
//   //   total > 0
//   //     ? ((depositAmount / (total - discountAmount)) * 100).toFixed(0)
//   //     : 0;
//   // const finalTotal = total - discountAmount;

//   const depositAmount = total - discountAmount; // Full payment now
//   const depositPercentage = 100; // Always 100%
//   const finalTotal = total - discountAmount;

//   const formatCurrency = (amount) => {
//     if (typeof amount !== "number")
//       return lang === "AR" ? "0.00 ج.م" : "EGP 0.00";
//     return lang === "AR"
//       ? `${amount.toFixed(2)} ج.م`
//       : `EGP ${amount.toFixed(2)}`;
//   };

//   const getProductName = (product) => {
//     if (!product) return "";
//     return lang === "AR" && product.nameAr ? product.nameAr : product.nameEn;
//   };

//   const getLocalizedName = (item) => {
//     if (!item) return "";
//     return lang === "AR" && item.nameAr ? item.nameAr : item.nameEn;
//   };

//   const calculateItemPrice = (price, isWithoutBox) => {
//     const basePrice = price || 0;
//     return isWithoutBox ? Math.max(0, basePrice - 100) : basePrice;
//   };

//   const calculateItemTotal = (price, quantity, isWithoutBox) => {
//     const itemPrice = calculateItemPrice(price, isWithoutBox);
//     return itemPrice * quantity || 0;
//   };

//   const getVariantInfo = (item) => {
//     const parts = [];
//     if (item.variant.color?.id) {
//       const colorName = getLocalizedName(item.variant.color);
//       parts.push(`${t.color}: ${colorName}`);
//     }
//     if (item.variant.size?.id) {
//       const sizeName = getLocalizedName(item.variant.size);
//       parts.push(`${t.size}: ${sizeName}`);
//     }
//     return parts.join(" • ");
//   };

//   const handleInputChange = (e) => {
//     const { name, value } = e.target;
//     setFormData((prev) => ({ ...prev, [name]: value }));
//     if (errors[name]) {
//       setErrors((prev) => ({ ...prev, [name]: "" }));
//     }
//   };

//   const validateForm = () => {
//     const newErrors = {};

//     if (!formData.fullName.trim()) newErrors.fullName = t.errors.nameRequired;
//     if (!formData.phone.trim()) newErrors.phone = t.errors.phoneRequired;

//     if (!authContext?.user && !formData.email?.trim()) {
//       newErrors.email = t.errors.emailRequired;
//     }

//     if (deliveryType === "delivery") {
//       if (!formData.address.trim())
//         newErrors.address = t.errors.addressRequired;
//       if (!formData.city.trim()) newErrors.city = t.errors.cityRequired;
//       if (!formData.state.trim()) newErrors.state = t.errors.stateRequired;
//     } else if (deliveryType === "pickup") {
//       if (!selectedBranch) {
//         toast.error(t.branches.selectBranchError);
//         return false;
//       }
//     }

//     setErrors(newErrors);
//     return Object.keys(newErrors).length === 0;
//   };

//   const handleImageUpload = async (e) => {
//     const file = e.target.files[0];
//     if (file) {
//       if (file.size > 5 * 1024 * 1024) {
//         toast.error(t.errors.imageSize);
//         return;
//       }

//       try {
//         const compressedFile = await compressImage(file, 800, 0.7);

//         setUploadedImage(compressedFile);
//         const reader = new FileReader();
//         reader.onloadend = () => {
//           setImagePreview(reader.result);
//         };
//         reader.readAsDataURL(compressedFile);
//       } catch (error) {
//         console.error("Error compressing image:", error);
//         setUploadedImage(file);
//         const reader = new FileReader();
//         reader.onloadend = () => {
//           setImagePreview(reader.result);
//         };
//         reader.readAsDataURL(file);
//       }
//     }
//   };

//   const removeImage = () => {
//     setUploadedImage(null);
//     setImagePreview(null);
//     if (fileInputRef.current) {
//       fileInputRef.current.value = "";
//     }
//   };

//   const goToNextStep = () => {
//     if (step === 1) {
//       if (validateForm()) {
//         setStep(2);
//       }
//     } else if (step === 2) {
//       setStep(3);
//     }
//   };

//   const handleSubmitOrder = async () => {
//      if (!uploadedImage) {
//         toast.error(t.errors.imageRequired);
//         return;
//       }

//     setIsSubmitting(true);

//     try {
//       const checkoutData = {
//         email: authContext?.user?.email || formData.email || "",
//         phone: formData.phone,
//         paymentMethod: formData.paymentMethod,
//         pickFromStore: deliveryType === "pickup",
//         orderNotes: formData.notes || null,
//         transactionId: `TRX-${Date.now()}-${Math.random().toString(36).substr(2, 9)}`,
//         promoCode: appliedPromo || null, // Send promo code to backend
//       };

//       if (deliveryType === "delivery") {
//         if (selectedAddressId && !useNewAddress) {
//           checkoutData.userAddressId = selectedAddressId;
//         } else {
//           checkoutData.shippingAddress = {
//             fullName: formData.fullName,
//             street: formData.address,
//             city: formData.city,
//             state: formData.state,
//             country: "Egypt",
//             phoneNumber: formData.phone,
//             latitude: formData.latitude,
//             longitude: formData.longitude,
//           };
//         }
//       } else {
//         checkoutData.storeAddress =
//           lang === "AR" ? selectedBranch.address.AR : selectedBranch.address.EN;

//         checkoutData.shippingAddress = {
//           fullName: formData.fullName,
//           street:
//             lang === "AR"
//               ? selectedBranch.address.AR
//               : selectedBranch.address.EN,
//           city: lang === "AR" ? selectedBranch.name.AR : selectedBranch.name.EN,
//           state: "Cairo",
//           country: "Egypt",
//           phoneNumber: formData.phone,
//         };
//       }

//       checkoutData.paymentProofFile = uploadedImage;

//       const response = await OrderApiService.completeCheckout(
//         checkoutId,
//         checkoutData,
//       );

//       if (response && response.orderId) {
//         setShowSuccess(true);
//         clearCart();
//         setShowSuccess(false);
//         // navigate to home and prevent going back to checkout page
//         navigate("/", { replace: true });
//       } else {
//         toast.error(
//           lang === "AR"
//             ? "حدث خطأ أثناء إتمام الطلب. حاول مرة أخرى."
//             : "An error occurred while completing the order. Please try again.",
//         );
//       }
//     } catch (error) {
//       console.error("Error completing checkout:", error);

//       const errorMessage =
//         error.response?.data?.message ||
//         (lang === "AR"
//           ? "حدث خطأ أثناء إتمام الطلب. حاول مرة أخرى."
//           : "An error occurred while completing the order. Please try again.");

//       toast.error(errorMessage);
//     } finally {
//       setIsSubmitting(false);
//     }
//   };

//   const getTimerColor = () => {
//     if (timeLeft > 180) return "#10b981";
//     if (timeLeft > 60) return "#f59e0b";
//     return "#ef4444";
//   };

//   useEffect(() => {
//     window.scrollTo({ top: 0, behavior: "smooth" });
//   }, [step]);

//   if (!cartItems || cartItems.length === 0) {
//     return (
//       <div className={`checkout-page expired ${lang === "AR" ? "rtl" : "ltr"}`}>
//         <div className="expired-container">
//           <div className="expired-icon">
//             <Package size={80} />
//           </div>
//           <h2>{t.emptyCart}</h2>
//           <p>{t.emptyCartMsg}</p>
//           <button className="retry-btn" onClick={() => navigate("/")}>
//             {t.goToShop}
//           </button>
//         </div>
//       </div>
//     );
//   }

//   if (isExpired) {
//     return (
//       <div className={`checkout-page expired ${lang === "AR" ? "rtl" : "ltr"}`}>
//         <div className="expired-container">
//           <div className="expired-icon">
//             <Clock size={80} />
//           </div>
//           <h2>{t.timer.expired}</h2>
//           <p>{t.timer.expiredMsg}</p>
//           <button className="retry-btn" onClick={() => navigate("/")}>
//             {t.timer.retry}
//           </button>
//         </div>
//       </div>
//     );
//   }

//   return (
//     <div
//       className={`checkout-page ${lang === "AR" ? "rtl" : "ltr"}`}
//       style={{ "--timer-color": getTimerColor() }}
//     >
//       <div className="timer-bar">
//         <div className="timer-content">
//           <Clock size={window.innerWidth <= 480 ? 16 : 20} />
//           <span className="timer-label">{t.timer.label}</span>
//           <span className="timer-value">{formatTime(timeLeft)}</span>
//         </div>
//         <div
//           className="timer-progress"
//           style={{ width: `${(timeLeft / 300) * 100}%` }}
//         />
//       </div>

//       <div className="checkout-container">
//         <div className="order-summary-sidebar">
//           <div className="summary-card">
//             <h3 className="summary-title">
//               <Package size={24} />
//               {t.summary.title}
//             </h3>

//             <div className="summary-items">
//               {cartItems.map((item, idx) => {
//                 const price = item.variant.discountPrice || item.variant.price;
//                 const displayPrice = calculateItemPrice(price, item.withoutBox);
//                 const itemTotal = calculateItemTotal(
//                   price,
//                   item.quantity,
//                   item.withoutBox,
//                 );

//                 return (
//                   <div
//                     key={`${item.product.id}-${item.variant.id}-${item.withoutBox ? "without" : "with"}-${idx}`}
//                     className="summary-item"
//                   >
//                     <div className="summary-item-image-wrapper">
//                       <img
//                         src={item.product.images[0]?.image_url}
//                         alt={getProductName(item.product)}
//                         className="summary-item-image"
//                         loading="lazy"
//                       />
//                       {item.withoutBox && (
//                         <span className="summary-without-box-badge">
//                           📦 {t.withoutBox}
//                         </span>
//                       )}
//                     </div>
//                     <div className="summary-item-details">
//                       <span className="summary-item-name">
//                         {getProductName(item.product)}
//                       </span>
//                       <span className="summary-item-variant">
//                         {getVariantInfo(item)}
//                       </span>
//                       <span className="summary-item-qty">
//                         {t.qty}: {item.quantity} ×{" "}
//                         {formatCurrency(displayPrice)}
//                       </span>
//                     </div>
//                     <span className="summary-item-price">
//                       {formatCurrency(itemTotal)}
//                     </span>
//                   </div>
//                 );
//               })}
//             </div>

//             <div className="summary-divider" />

//             <div className="summary-totals">
//               <div className="summary-row">
//                 <span>{t.summary.subtotal}</span>
//                 <span>{formatCurrency(subtotal)}</span>
//               </div>

//               {/* Discount Row */}
//               {discountAmount > 0 && (
//                 <div className="summary-row discount">
//                   <span>{t.summary.discount}</span>
//                   <span>-{formatCurrency(discountAmount)}</span>
//                 </div>
//               )}

//               <div className="summary-row">
//                 <span>{t.summary.shipping}</span>
//                 <span className={shipping === 0 ? "free" : ""}>
//                   {shipping === 0 ? t.summary.free : formatCurrency(shipping)}
//                 </span>
//               </div>
//               <div className="summary-divider-thin" />
//               <div className="summary-row total">
//                 <span>{t.summary.total}</span>
//                 <span>{formatCurrency(finalTotal)}</span>
//               </div>
//             </div>

//             {/* Promo Code Section */}
//             <div className="promo-code-section">
//               {!appliedPromo ? (
//                 <>
//                   <div className="promo-input-wrapper">
//                     <input
//                       type="text"
//                       className="promo-input"
//                       placeholder={t.summary.promoPlaceholder}
//                       value={promoCode}
//                       onChange={(e) => setPromoCode(e.target.value)}
//                       onKeyPress={(e) =>
//                         e.key === "Enter" && handleApplyPromo()
//                       }
//                     />
//                     <button
//                       className="promo-apply-btn"
//                       onClick={handleApplyPromo}
//                       disabled={isApplyingPromo || !promoCode.trim()}
//                     >
//                       {isApplyingPromo ? (
//                         <div className="spinner-small" />
//                       ) : (
//                         t.summary.apply
//                       )}
//                     </button>
//                   </div>
//                   {promoError && (
//                     <div className="promo-error">{promoError}</div>
//                   )}
//                   {promoSuccess && (
//                     <div className="promo-success">{promoSuccess}</div>
//                   )}
//                 </>
//               ) : (
//                 <div className="promo-applied">
//                   <div className="promo-applied-content">
//                     <Tag size={16} />
//                     <span>
//                       {t.summary.applied} <strong>{appliedPromo}</strong>
//                     </span>
//                   </div>
//                   <button
//                     className="promo-remove-btn"
//                     onClick={handleRemovePromo}
//                   >
//                     <X size={16} />
//                   </button>
//                 </div>
//               )}
//             </div>

//             <div className="deposit-notice">
//               <CreditCard size={20} />
//               <div>
//                 <div className="deposit-label">{t.summary.depositLabel}</div>
//                 <div className="deposit-amount">
//                   {formatCurrency(depositAmount)}
//                 </div>
//                 <div className="deposit-desc">
//                   {t.summary.depositDesc}
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>

//         <div className="checkout-main">
//           <div className="progress-steps">
//             <div
//               className={`step ${step >= 1 ? "active" : ""} ${step > 1 ? "completed" : ""}`}
//             >
//               <div className="step-circle">
//                 {step > 1 ? <CheckCircle size={20} /> : <span>1</span>}
//               </div>
//               <span className="step-label">{t.steps.info}</span>
//             </div>
//             <div className="step-line" />
//             <div
//               className={`step ${step >= 2 ? "active" : ""} ${step > 2 ? "completed" : ""}`}
//             >
//               <div className="step-circle">
//                 {step > 2 ? <CheckCircle size={20} /> : <span>2</span>}
//               </div>
//               <span className="step-label">{t.steps.payment}</span>
//             </div>
//             <div className="step-line" />
//             <div className={`step ${step >= 3 ? "active" : ""}`}>
//               <div className="step-circle">
//                 <span>3</span>
//               </div>
//               <span className="step-label">{t.steps.confirm}</span>
//             </div>
//           </div>
//           {step === 1 && (
//             <div className="step-content">
//               <h2 className="step-title">{t.step1.title}</h2>

//               <div className="delivery-type-section">
//                 <h3 className="delivery-type-title">
//                   {t.deliveryOptions.title}
//                 </h3>
//                 <div className="delivery-options-grid">
//                   <div
//                     className={`delivery-option ${deliveryType === "delivery" ? "selected" : ""}`}
//                     onClick={() => handleDeliveryTypeChange("delivery")}
//                   >
//                     <div className="delivery-option-icon">;
//                       <Package size={32} />
//                     </div>
//                     <div className="delivery-option-content">
//                       <h4>{t.deliveryOptions.delivery.title}</h4>
//                       <p>{t.deliveryOptions.delivery.desc}</p>
//                     </div>
//                     <div className="delivery-option-radio">
//                       <div
//                         className={`radio-dot ${deliveryType === "delivery" ? "active" : ""}`}
//                       />
//                     </div>
//                   </div>

//                   <div
//                     className={`delivery-option ${deliveryType === "pickup" ? "selected" : ""}`}
//                     onClick={() => handleDeliveryTypeChange("pickup")}
//                   >
//                     <div className="delivery-option-icon">
//                       <Store size={32} />
//                     </div>
//                     <div className="delivery-option-content">
//                       <h4>{t.deliveryOptions.pickup.title}</h4>
//                       <p>{t.deliveryOptions.pickup.desc}</p>
//                     </div>
//                     <div className="delivery-option-radio">
//                       <div
//                         className={`radio-dot ${deliveryType === "pickup" ? "active" : ""}`}
//                       />
//                     </div>
//                   </div>
//                 </div>
//               </div>

//               <div className="personal-info-section">
//                 <div className="form-grid">
//                   <div className="form-group full-width">
//                     <label>
//                       <User size={18} />
//                       {t.step1.fullName}
//                     </label>
//                     <input
//                       type="text"
//                       name="fullName"
//                       value={formData.fullName}
//                       onChange={handleInputChange}
//                       placeholder={t.step1.fullNamePlaceholder}
//                       className={errors.fullName ? "error" : ""}
//                     />
//                     {errors.fullName && (
//                       <span className="error-msg">{errors.fullName}</span>
//                     )}
//                   </div>

//                   <div className="form-group">
//                     <label>
//                       <Phone size={18} />
//                       {t.step1.phone}
//                     </label>
//                     <input
//                       type="tel"
//                       name="phone"
//                       value={formData.phone}
//                       onChange={handleInputChange}
//                       placeholder={t.step1.phonePlaceholder}
//                       className={errors.phone ? "error" : ""}
//                     />
//                     {errors.phone && (
//                       <span className="error-msg">{errors.phone}</span>
//                     )}
//                   </div>

//                   {!authContext?.user && (
//                     <div className="form-group">
//                       <label>
//                         <User size={18} />
//                         {t.step1.email}
//                       </label>
//                       <input
//                         type="email"
//                         name="email"
//                         value={formData.email || ""}
//                         onChange={handleInputChange}
//                         placeholder={t.step1.emailPlaceholder}
//                         className={errors.email ? "error" : ""}
//                       />
//                       {errors.email && (
//                         <span className="error-msg">{errors.email}</span>
//                       )}
//                     </div>
//                   )}
//                 </div>
//               </div>

//               {deliveryType === "delivery" && (
//                 <>
//                   {isLoadingAddresses ? (
//                     <div className="loading-addresses-section">
//                       <div className="spinner" />
//                       <p>{t.step1.loadingAddresses}</p>
//                     </div>
//                   ) : (
//                     savedAddresses.length > 0 &&
//                     authContext?.user && (
//                       <div className="saved-addresses-section">
//                         <h3 className="addresses-section-title">
//                           {t.step1.savedAddresses}
//                         </h3>
//                         <div className="saved-addresses-grid">
//                           {savedAddresses.map((address) => (
//                             <div
//                               key={address.id}
//                               className={`saved-address-card ${selectedAddressId === address.id ? "selected" : ""}`}
//                               onClick={() => handleAddressSelect(address.id)}
//                             >
//                               <div className="address-radio">
//                                 <div
//                                   className={`radio-dot ${selectedAddressId === address.id ? "active" : ""}`}
//                                 />
//                               </div>
//                               <div className="address-info">
//                                 <div className="address-header">
//                                   <MapPin size={18} />
//                                   {address.isDefault && (
//                                     <span className="default-badge-small">
//                                       {t.default}
//                                     </span>
//                                   )}
//                                 </div>
//                                 <p className="address-street">
//                                   {address.street}
//                                 </p>
//                                 <p className="address-city">
//                                   {address.city}, {address.state}
//                                 </p>
//                                 {address.phoneNumber && (
//                                   <p className="address-phone">
//                                     <Phone size={14} />
//                                     {address.phoneNumber}
//                                   </p>
//                                 )}
//                               </div>
//                             </div>
//                           ))}

//                           <div
//                             className={`saved-address-card new-address ${useNewAddress ? "selected" : ""}`}
//                             onClick={handleUseNewAddress}
//                           >
//                             <div className="address-radio">
//                               <div
//                                 className={`radio-dot ${useNewAddress ? "active" : ""}`}
//                               />
//                             </div>
//                             <div className="address-info new-address-content">
//                               <Plus size={24} />
//                               <p>{t.step1.useNewAddress}</p>
//                             </div>
//                           </div>
//                         </div>
//                       </div>
//                     )
//                   )}

//                   {/* INLINE MAP SECTION - Show only if user is not logged in OR chooses new address */}
//                   {(!authContext?.user || useNewAddress) && (
//                     <div className="inline-map-section">
//                       <div className="map-section-header">
//                         <h3 className="map-section-title">
//                           <MapPin size={20} />
//                           {t.step1.mapTitle}
//                         </h3>
//                         <p className="map-section-subtitle">
//                           {t.step1.mapInstruction}
//                         </p>
//                       </div>

//                       <div className="inline-map-controls">
//                         <div className="inline-map-search">
//                           <Search size={18} />
//                           <input
//                             type="text"
//                             placeholder={t.step1.search}
//                             value={searchQuery}
//                             onChange={(e) => setSearchQuery(e.target.value)}
//                             onKeyPress={(e) =>
//                               e.key === "Enter" && handleMapSearch()
//                             }
//                           />
//                           <button
//                             onClick={handleMapSearch}
//                             disabled={isSearching}
//                           >
//                             {t.step1.searchBtn}
//                           </button>
//                         </div>
//                         <button
//                           className="inline-map-current-location"
//                           onClick={getCurrentLocation}
//                         >
//                           <Navigation size={18} />
//                           {t.step1.currentLocation}
//                         </button>
//                       </div>

//                       <div className="inline-map-container">
//                         <div id="inline-leaflet-map"></div>
//                       </div>
//                     </div>
//                   )}

//                   <div className="address-form-section">
//                     <h3 className="address-form-title">
//                       {!authContext?.user
//                         ? t.step1.useNewAddress
//                         : useNewAddress || savedAddresses.length === 0
//                           ? t.step1.useNewAddress
//                           : t.step1.selectAddress}
//                     </h3>

//                     <div className="form-grid">
//                       <div className="form-group">
//                         <label>
//                           <MapPin size={18} />
//                           {t.step1.city}
//                         </label>
//                         <input
//                           type="text"
//                           name="city"
//                           value={formData.city}
//                           onChange={handleInputChange}
//                           placeholder={t.step1.cityPlaceholder}
//                           className={errors.city ? "error" : ""}
//                         />
//                         {errors.city && (
//                           <span className="error-msg">{errors.city}</span>
//                         )}
//                       </div>

//                       <div className="form-group">
//                         <label>
//                           <MapPin size={18} />
//                           {t.step1.state}
//                         </label>
//                         <div className="select-wrapper-glass">
//                           <select
//                             name="state"
//                             value={formData.state}
//                             onChange={handleInputChange}
//                             className={`form-input-glass select-input ${errors.state ? "error" : ""}`}
//                           >
//                             <option value="">{t.step1.selectState}</option>
//                             {governoratesList.map((gov) => (
//                               <option
//                                 key={gov.id}
//                                 defaultValue={
//                                   lang === "EN" ? gov.nameEn : gov.nameAr
//                                 }
//                               >
//                                 {lang === "EN" ? gov.nameEn : gov.nameAr}
//                               </option>
//                             ))}
//                           </select>
//                           <ChevronDown className="select-arrow" size={18} />
//                         </div>
//                         {errors.state && (
//                           <span className="error-msg">{errors.state}</span>
//                         )}
//                       </div>

//                       <div className="form-group full-width">
//                         <label>
//                           <MapPin size={18} />
//                           {t.step1.address}
//                         </label>
//                         <textarea
//                           name="address"
//                           value={formData.address}
//                           onChange={handleInputChange}
//                           placeholder={t.step1.addressPlaceholder}
//                           rows="3"
//                           className={errors.address ? "error" : ""}
//                         />
//                         {errors.address && (
//                           <span className="error-msg">{errors.address}</span>
//                         )}
//                       </div>
//                     </div>
//                   </div>
//                 </>
//               )}

//               {deliveryType === "pickup" && (
//                 <div className="branches-section">
//                   <h3 className="branches-section-title">{t.branches.title}</h3>
//                   <div className="branches-grid">
//                     {branches.map((branch) => (
//                       <div
//                         key={branch.id}
//                         className={`branch-card ${selectedBranch?.id === branch.id ? "selected" : ""}`}
//                         onClick={() => handleBranchSelect(branch)}
//                       >
//                         <div className="branch-radio">
//                           <div
//                             className={`radio-dot ${selectedBranch?.id === branch.id ? "active" : ""}`}
//                           />
//                         </div>
//                         <div className="branch-content">
//                           <div className="branch-header">
//                             <Store size={20} />
//                             <h4>
//                               {lang === "AR" ? branch.name.AR : branch.name.EN}
//                             </h4>
//                           </div>
//                           <div className="branch-details">
//                             <p className="branch-address">
//                               <MapPin size={16} />
//                               <span>
//                                 {lang === "AR"
//                                   ? branch.address.AR
//                                   : branch.address.EN}
//                               </span>
//                             </p>
//                             <p className="branch-phone">
//                               <Phone size={16} />
//                               <span>{branch.phone}</span>
//                             </p>
//                             <p className="branch-hours">
//                               <Clock size={16} />
//                               <span>
//                                 {lang === "AR"
//                                   ? branch.hours.AR
//                                   : branch.hours.EN}
//                               </span>
//                             </p>
//                           </div>
//                         </div>
//                       </div>
//                     ))}
//                   </div>
//                 </div>
//               )}

//               <div className="form-group full-width notes-section">
//                 <label>{t.step1.notes}</label>
//                 <textarea
//                   name="notes"
//                   value={formData.notes}
//                   onChange={handleInputChange}
//                   placeholder={t.step1.notesPlaceholder}
//                   rows="2"
//                 />
//               </div>

//               <button className="next-btn" onClick={goToNextStep}>
//                 {t.step1.nextBtn}
//                 <ArrowRight size={20} />
//               </button>
//             </div>
//           )}
//           {step === 2 && (
//             <div className="step-content">
//               <h2 className="step-title">{t.step2.title}</h2>

//               <div className="payment-methods">
//                 <>
//                   <div
//                     className={`payment-method ${formData.paymentMethod === "INSTAPAY" ? "selected" : ""}`}
//                     onClick={() =>
//                       setFormData((prev) => ({
//                         ...prev,
//                         paymentMethod: "INSTAPAY",
//                       }))
//                     }
//                   >
//                     <QrCode size={32} />
//                     <div>
//                       <div className="method-name">{t.step2.instapay.name}</div>
//                       <div className="method-desc">{t.step2.instapay.desc}</div>
//                     </div>
//                   </div>

//                   <div
//                     className={`payment-method ${formData.paymentMethod === "DIGITAL_WALLET" ? "selected" : ""}`}
//                     onClick={() =>
//                       setFormData((prev) => ({
//                         ...prev,
//                         paymentMethod: "DIGITAL_WALLET",
//                       }))
//                     }
//                   >
//                     <Smartphone size={32} />
//                     <div>
//                       <div className="method-name">{t.step2.wallet.name}</div>
//                       <div className="method-desc">{t.step2.wallet.desc}</div>
//                     </div>
//                   </div>
//                 </>
//               </div>

//               <div className="payment-instructions">
//                 <div className="instruction-header">
//                   <AlertCircle size={24} />
//                   <h3>{t.step2.instructionsTitle}</h3>
//                 </div>

//                   <>
//                     {/* InstaPay Instructions */}
//                     {formData.paymentMethod === "INSTAPAY" && (
//                       <div className="instapay-transfer-section">
//                         {/* InstaPay Link Button */}
//                         <a
//                           href="https://ipn.eg/S/addmixstore/instapay/52sPTk"
//                           target="_blank"
//                           rel="noopener noreferrer"
//                           className="instapay-link-button"
//                         >
//                           <div className="instapay-link-content">
//                             <QrCode size={24} />
//                             <div>
//                               <div className="instapay-link-title">
//                                 {t.step2.instaPayLink}
//                               </div>
//                               <div className="instapay-link-desc">
//                                 {t.step2.instaPayLinkDesc}
//                               </div>
//                             </div>
//                           </div>
//                           <ArrowRight
//                             size={20}
//                             className={lang === "AR" ? "rotate-180" : ""}
//                           />
//                         </a>

//                         {/* Divider */}
//                         {/* <div className="transfer-divider">
//                           <span>{t.step2.orText}</span>
//                         </div> */}

//                         {/* Manual Transfer */}
//                         {/* <div className="manual-transfer-section">
//                           <p className="transfer-label">
//                             {t.step2.transferManually}
//                           </p>
//                           <div className="phone-number instapay-number">
//                             {t.step2.instaPayNumber}
//                           </div>
//                         </div> */}
//                       </div>
//                     )}

//                     {/* Digital Wallet Instructions */}
//                     {formData.paymentMethod === "DIGITAL_WALLET" && (
//                       <div className="wallet-transfer-section">
//                         {/* <ol className="instruction-list"> */}
//                           {/* <li> */}
//                             {t.step2.instruction1}{" "}
//                             <strong>{depositAmount.toFixed(2)}</strong>{" "}
//                             {t.step2.instruction1b}
//                             <div className="phone-number wallet-number">
//                               {t.step2.walletNumber}
//                             </div>
//                           {/* </li> */}
//                           {/* <li>{t.step2.instruction2}</li>
//                           <li>{t.step2.instruction3}</li>
//                           <li>{t.step2.instruction4}</li>
//                           <li>{t.step2.instruction5}</li> */}
//                         {/* </ol> */}
//                       </div>
//                     )}

//                     <div className="additional-instructions">
//                       <h4 className="additional-instructions-title">
//                         {deliveryType === "delivery"
//                           ? lang === "AR"
//                             ? "خطوات إضافية:"
//                             : "Additional Steps:"
//                           : lang === "AR"
//                             ? "خطوات الاستلام:"
//                             : "Pickup Steps:"}
//                       </h4>
//                       <ol className="instruction-list secondary">
//                         {deliveryType === "delivery" ? (
//                           <>
//                             <li>{t.step2.instruction2}</li>
//                             <li>{t.step2.instruction3}</li>
//                             <li>{t.step2.instruction4}</li>
//                           </>
//                         ) : (
//                           <>
//                             <li>{t.step2.instructionPickup2}</li>
//                             <li>{t.step2.instructionPickup3}</li>
//                             <li>{t.step2.instructionPickup4}</li>
//                             <li>{t.step2.instructionPickup5}</li>
//                           </>
//                         )}
//                       </ol>
//                     </div>

//                     <div className="payment-note">
//                       <strong>{t.step2.note}</strong> {t.step2.noteText}{" "}
//                       {formatTime(timeLeft)} {t.step2.noteText2}
//                     </div>
//                   </>
//               </div>

//               <div className="step-actions">
//                 <button className="back-btn" onClick={() => setStep(1)}>
//                   {t.step2.backBtn}
//                 </button>
//                 <button className="next-btn" onClick={goToNextStep}>
//                   {deliveryType === "pickup"
//                     ? t.step2.nextBtnPickup
//                     : t.step2.nextBtn}
//                   <ArrowRight size={20} />
//                 </button>
//               </div>
//             </div>
//           )}
//           {step === 3 && (
//             <div className="step-content">
//               <h2 className="step-title">
//                 {deliveryType === "pickup"
//                   ? t.step3.titlePickup
//                   : t.step3.title}
//               </h2>

//               <div className="upload-section">
//                 {!imagePreview ? (
//                   <div
//                     className="upload-area"
//                     onClick={() => fileInputRef.current?.click()}
//                   >
//                     <div className="upload-icon">
//                       <Image size={48} />
//                     </div>
//                     <h3>{t.step3.uploadTitle}</h3>
//                     <p>{t.step3.uploadDesc}</p>
//                     <input
//                       ref={fileInputRef}
//                       type="file"
//                       accept="image/*"
//                       onChange={handleImageUpload}
//                       style={{ display: "none" }}
//                     />
//                   </div>
//                 ) : (
//                   <div className="preview-area">
//                     <button className="remove-image-btn" onClick={removeImage}>
//                       <X size={20} />
//                     </button>
//                     <img
//                       src={imagePreview}
//                       alt="Payment proof"
//                       className="preview-image"
//                     />
//                     <div className="preview-info">
//                       <FileCheck size={20} />
//                       <span>{uploadedImage?.name}</span>
//                     </div>
//                   </div>
//                 )}
//               </div>

//               <div className="final-review">
//                 <h3>{t.step3.reviewTitle}</h3>
//                 <div className="review-grid">
//                   <div className="review-item">
//                     <span className="review-label">{t.step3.name}</span>
//                     <span className="review-value">{formData.fullName}</span>
//                   </div>
//                   <div className="review-item">
//                     <span className="review-label">{t.step3.phone}</span>
//                     <span className="review-value">{formData.phone}</span>
//                   </div>

//                   {deliveryType === "delivery" ? (
//                     <>
//                       <div className="review-item">
//                         <span className="review-label">{t.step3.city}</span>
//                         <span className="review-value">{formData.city}</span>
//                       </div>
//                       <div className="review-item">
//                         <span className="review-label">{t.step3.state}</span>
//                         <span className="review-value">{formData.state}</span>
//                       </div>
//                       <div className="review-item full">
//                         <span className="review-label">{t.step3.address}</span>
//                         <span className="review-value">{formData.address}</span>
//                       </div>
//                     </>
//                   ) : (
//                     <div className="review-item full">
//                       <span className="review-label">{t.step3.branch}</span>
//                       <span className="review-value">
//                         {lang === "AR"
//                           ? selectedBranch?.name.AR
//                           : selectedBranch?.name.EN}
//                       </span>
//                     </div>
//                   )}

//                   <div className="review-item">
//                     <span className="review-label">{t.step3.deliveryType}</span>
//                     <span className="review-value">
//                       {deliveryType === "delivery"
//                         ? t.deliveryOptions.delivery.title
//                         : t.deliveryOptions.pickup.title}
//                     </span>
//                   </div>

//                   <div className="review-item">
//                     <span className="review-label">
//                       {t.step3.paymentMethod}
//                     </span>
//                     <span className="review-value">
//                       {formData.paymentMethod === "CASH" && t.step2.cash.name}
//                       {formData.paymentMethod === "INSTAPAY" &&
//                         t.step2.instapay.name}
//                       {formData.paymentMethod === "DIGITAL_WALLET" &&
//                         t.step2.wallet.name}
//                     </span>
//                   </div>

//                   {deliveryType === "delivery" && (
//                     <div className="review-item">
//                       <span className="review-label">{t.step3.amountPaid}</span>
//                       <span className="review-value">
//                         {formatCurrency(depositAmount)}
//                       </span>
//                     </div>
//                   )}

//                   {/* Promo Code in Review */}
//                   {appliedPromo && (
//                     <div className="review-item">
//                       <span className="review-label">{t.summary.promo}</span>
//                       <span
//                         className="review-value"
//                         style={{ color: "#10b981", fontWeight: "700" }}
//                       >
//                         {appliedPromo} (-{formatCurrency(discountAmount)})
//                       </span>
//                     </div>
//                   )}
//                 </div>
//               </div>

//               <div className="step-actions">
//                 <button className="back-btn" onClick={() => setStep(2)}>
//                   {t.step3.backBtn}
//                 </button>
//                 <button
//                   className="submit-btn"
//                   onClick={handleSubmitOrder}
//                   disabled={isSubmitting}
//                 >
//                   {isSubmitting ? (
//                     <>
//                       <div className="spinner" />
//                       {t.step3.submitting}
//                     </>
//                   ) : (
//                     <>
//                       <CheckCircle size={20} />
//                       {t.step3.submitBtn}
//                     </>
//                   )}
//                 </button>
//               </div>
//             </div>
//           )}
//         </div>
//       </div>

//       {showSuccess && (
//         <div className="success-overlay">
//           <div className="success-modal">
//             <div className="success-icon">
//               <CheckCircle size={80} />
//             </div>
//             <h2>{t.success.title}</h2>
//             <p>{t.success.message}</p>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default CheckoutPage;

import { useState, useEffect, useRef } from "react";
import {
  Clock,
  CheckCircle,
  AlertCircle,
  Package,
  MapPin,
  Phone,
  User,
  CreditCard,
  Store,
  ArrowRight,
  X,
  Image,
  FileCheck,
  Smartphone,
  QrCode,
  Plus,
  ChevronDown,
  Navigation,
  Search,
  Tag,
} from "lucide-react";
import "./CheckoutPage.scss";
import { getLanguage } from "../../utils/Helper";
import { useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import { useCart } from "../../context/CartContext";
import { toast } from "react-toastify";
import { fetchUserAddresses } from "../../services/UsersApiService";
import OrderApiService from "../../services/OrderApiService";
import { HttpStatusCode } from "axios";
import { compressImage } from "../../utils/imageCompressor";
import StatesApiService from "../../services/StatesApiService";

const CheckoutPage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const authContext = useAuth();

  const [states, setStates] = useState([]);
  const [isLoadingStates, setIsLoadingStates] = useState(false);
  const [selectedStateDeliveryFees, setSelectedStateDeliveryFees] = useState(0);

  const checkoutSession = location.state || {};
  const { checkoutId, expiresAt, expiresIn } = checkoutSession;

  useEffect(() => {
    if (!checkoutId) {
      const lang = getLanguage();
      toast.error(
        lang === "AR"
          ? "يجب ان تبدأ من السلة"
          : "Start checkout from your cart",
      );
      navigate("/");
    }
  }, [checkoutId, navigate]);

  const getInitialTimeLeft = () => {
    if (expiresIn) return expiresIn;
    if (expiresAt) {
      const expiryDate = new Date(expiresAt);
      const now = new Date();
      const secondsLeft = Math.floor((expiryDate - now) / 1000);
      return Math.max(0, secondsLeft);
    }
    return 300;
  };

  const [timeLeft, setTimeLeft] = useState(getInitialTimeLeft());
  const [isExpired, setIsExpired] = useState(false);
  const [step, setStep] = useState(1);
  const [uploadedImage, setUploadedImage] = useState(null);
  const [imagePreview, setImagePreview] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);
  const fileInputRef = useRef(null);
  const lang = getLanguage();

  const [savedAddresses, setSavedAddresses] = useState([]);
  const [isLoadingAddresses, setIsLoadingAddresses] = useState(false);
  const [selectedAddressId, setSelectedAddressId] = useState(null);
  const [useNewAddress, setUseNewAddress] = useState(false);
  const [deliveryType, setDeliveryType] = useState("delivery");
  const [selectedBranch, setSelectedBranch] = useState(null);

  // Leaflet Maps States
  const [selectedLocation, setSelectedLocation] = useState({
    lat: 30.0444,
    lng: 31.2357,
  });
  const [searchQuery, setSearchQuery] = useState("");
  const [isSearching, setIsSearching] = useState(false);
  const [mapInitialized, setMapInitialized] = useState(false);
  const markerRef = useRef(null);
  const leafletMapRef = useRef(null);

  // Promo Code States
  const [promoCode, setPromoCode] = useState("");
  const [appliedPromo, setAppliedPromo] = useState(null);
  const [isApplyingPromo, setIsApplyingPromo] = useState(false);
  const [promoError, setPromoError] = useState("");
  const [promoSuccess, setPromoSuccess] = useState("");
  const [discountAmount, setDiscountAmount] = useState(0);

  const [formData, setFormData] = useState({
    fullName: "",
    phone: "",
    email: "",
    address: "",
    city: "",
    state: "",
    notes: "",
    paymentMethod: "INSTAPAY",
    latitude: null,
    longitude: null,
  });

  const [errors, setErrors] = useState({});

  // ✅ FIX #1: Remove 'total' from useCart - we'll calculate it ourselves with shipping
  const { cartItems, subtotal, clearCart } = useCart();

  const branches = [
    {
      id: 1,
      name: { EN: "Al-Mokatam Branch", AR: "فرع المقطم" },
      address: {
        EN: "Al-Mokatam, Middle Hills, Modern University Street, next to Shahpur Pharmacy",
        AR: "المقطم الهضبة الوسطي، شارع الجامعة الحديثة بجوار صيدلية شاهبور",
      },
      phone: "01006611664",
      hours: { EN: "Daily: 9 AM - 2 PM", AR: "يومياً: 9 صباحاً - 2 مساءً" },
    },
  ];

  const content = {
    EN: {
      timer: {
        label: "Time Remaining:",
        expired: "Time's Up",
        expiredMsg:
          "Sorry, your reservation time has expired. Please return to cart and try again.",
        retry: "Back to Home",
      },
      summary: {
        title: "Order Summary",
        subtotal: "Subtotal",
        shipping: "Shipping",
        free: "Free",
        total: "Total",
        depositLabel: "Total Amount to Transfer",
        depositDesc: "full payment required",
        promo: "Promo Code",
        promoPlaceholder: "Enter promo code",
        apply: "Apply",
        applied: "Promo applied:",
        remove: "Remove",
        discount: "Discount",
      },
      steps: {
        info: "Information",
        payment: "Payment",
        confirm: "Confirmation",
      },
      deliveryOptions: {
        title: "Delivery Method",
        delivery: {
          title: "Home Delivery",
          desc: "Get your order delivered to your address",
        },
        pickup: {
          title: "Store Pickup",
          desc: "Pick up your order from our branch",
        },
      },
      step1: {
        title: "Shipping Information",
        savedAddresses: "Saved Addresses",
        selectAddress: "Select an address",
        useNewAddress: "Use a new address",
        fullName: "Full Name *",
        fullNamePlaceholder: "Enter your full name",
        phone: "Phone Number *",
        phonePlaceholder: "01xxxxxxxxx",
        email: "Email *",
        emailPlaceholder: "your@email.com",
        city: "City *",
        cityPlaceholder: "Maadi, Mokatam...",
        state: "Governorate *",
        selectState: "Select governorate",
        address: "Detailed Address *",
        addressPlaceholder: "Street, area, building number, floor...",
        notes: "Notes (Optional)",
        notesPlaceholder: "Any additional notes or instructions...",
        nextBtn: "Next: Payment Method",
        required: "Required field",
        loadingAddresses: "Loading addresses...",
        mapTitle: "Select Location on Map",
        mapInstruction: "Click or drag the pin to your exact location",
        currentLocation: "My Location",
        search: "Search for address...",
        searchBtn: "Search",
      },
      branches: {
        title: "Select Branch",
        selectBranch: "Choose pickup branch",
        selectBranchError: "Please select a branch",
      },
      step2: {
        title: "Payment Method",
        cash: {
          name: "Cash on Delivery",
          desc: "Pay when you receive your order",
        },
        instapay: { name: "InstaPay", desc: "Instant transfer" },
        wallet: {
          name: "Digital Wallet",
          desc: "Orange/Vodafone/Etislat/WE wallet",
        },
        instructionsTitle: "Payment Instructions",
        instruction1: "Transfer",
        instruction1b: "EGP to the following number:",
        instruction2: "Keep the transfer receipt (Screenshot)",
        instruction3: "Upload the receipt image in the next step",
        instruction4: "Your order will be reviewed within 24 hours",
        instruction5: "Full payment required via transfer",
        instructionPickup1: "Transfer full amount before pickup",
        instructionPickup2: "Keep the transfer receipt (Screenshot)",
        instructionPickup3: "Upload the receipt image in the next step",
        instructionPickup4: "We'll contact you when order is ready",
        instructionPickup5: "Present your receipt when collecting your order",
        instaPayNumber: "01678900000",
        walletNumber: "01006611664",
        instaPayLink: "Transfer via InstaPay Link",
        instaPayLinkDesc: "Click to open InstaPay app directly",
        orText: "Or",
        transferManually: "Transfer manually to:",
        note: "Important Note:",
        noteText: "After completing the transfer, you have",
        noteText2: "to complete the order before reservation cancellation",
        notePickup: "You can proceed directly to confirmation",
        backBtn: "Back",
        nextBtn: "Next: Upload Receipt",
        nextBtnPickup: "Next: Upload Receipt",
      },
      step3: {
        title: "Upload Payment Receipt",
        titlePickup: "Final Review & Confirmation",
        uploadTitle: "Click to upload receipt image",
        uploadDesc: "PNG, JPG or JPEG (Max 5MB)",
        uploadOptional: "(Optional for pickup orders)",
        reviewTitle: "Final Review",
        name: "Name:",
        phone: "Phone:",
        email: "Email:",
        city: "City:",
        state: "Governorate:",
        address: "Address:",
        paymentMethod: "Payment Method:",
        amountPaid: "Amount Paid:",
        deliveryType: "Delivery Method:",
        branch: "Pickup Branch:",
        shippingFee: "Shipping Fee:",
        backBtn: "Back",
        submitBtn: "Confirm & Complete Order",
        submitting: "Processing order...",
      },
      success: {
        title: "Order Submitted Successfully!",
        message: "Your order will be reviewed and we'll contact you soon",
      },
      errors: {
        nameRequired: "Name is required",
        phoneRequired: "Phone number is required",
        emailRequired: "Email is required",
        addressRequired: "Address is required",
        cityRequired: "City is required",
        stateRequired: "Governorate is required",
        imageRequired: "Please upload transfer receipt first",
        imageSize: "Image size is too large! Maximum 5MB",
        promoInvalid: "Invalid promo code",
        promoApplied: "Promo code applied successfully!",
      },
      emptyCart: "Your cart is empty",
      emptyCartMsg: "Please add items to cart first",
      goToShop: "Go to Shop",
      color: "Color",
      size: "Size",
      withoutBox: "Without Box",
      qty: "Qty",
      default: "Default",
    },
    AR: {
      timer: {
        label: "الوقت المتبقي:",
        expired: "انتهى الوقت المخصص",
        expiredMsg:
          "عذراً، انتهت مدة الحجز للمنتجات. من فضلك ارجع للسلة وأعد المحاولة.",
        retry: "العودة للرئيسية",
      },
      summary: {
        title: "ملخص الطلب",
        subtotal: "المجموع الفرعي",
        shipping: "الشحن",
        free: "مجاناً",
        total: "الإجمالي",
        depositLabel: "المبلغ الإجمالي المطلوب تحويله",
        depositDesc: "يجب دفع المبلغ كاملاً",
        promo: "كود الخصم",
        promoPlaceholder: "أدخل كود الخصم",
        apply: "تطبيق",
        applied: "تم تطبيق الكود:",
        remove: "إزالة",
        discount: "الخصم",
      },
      steps: { info: "البيانات", payment: "الدفع", confirm: "التأكيد" },
      deliveryOptions: {
        title: "طريقة التوصيل",
        delivery: { title: "توصيل للمنزل", desc: "احصل على طلبك في عنوانك" },
        pickup: { title: "استلام من الفرع", desc: "استلم طلبك من أقرب فرع" },
      },
      step1: {
        title: "معلومات التوصيل",
        savedAddresses: "العناوين المحفوظة",
        selectAddress: "اختر عنواناً",
        useNewAddress: "استخدام عنوان جديد",
        fullName: "الاسم الكامل *",
        fullNamePlaceholder: "أدخل اسمك الكامل",
        phone: "رقم الهاتف *",
        phonePlaceholder: "01xxxxxxxxx",
        email: "البريد الإلكتروني *",
        emailPlaceholder: "your@email.com",
        city: "المدينة *",
        cityPlaceholder: "المعادي, المقطم، ...",
        state: "المحافظة *",
        selectState: "اختر المحافظة",
        address: "العنوان بالتفصيل *",
        addressPlaceholder: "الشارع، المنطقة، رقم المبنى، الدور...",
        notes: "ملاحظات (اختياري)",
        notesPlaceholder: "أي ملاحظات أو تعليمات إضافية...",
        nextBtn: "التالي: طريقة الدفع",
        required: "حقل مطلوب",
        loadingAddresses: "جاري تحميل العناوين...",
        mapTitle: "حدد موقعك على الخريطة",
        mapInstruction: "اضغط أو اسحب الدبوس لموقعك بالضبط",
        currentLocation: "موقعي الحالي",
        search: "ابحث عن عنوان...",
        searchBtn: "بحث",
      },
      branches: {
        title: "اختر الفرع",
        selectBranch: "اختر فرع الاستلام",
        selectBranchError: "برجاء اختيار فرع الاستلام",
      },
      step2: {
        title: "طريقة الدفع",
        cash: { name: "الدفع عند الاستلام", desc: "ادفع عند استلام طلبك" },
        instapay: { name: "InstaPay", desc: "التحويل الفوري" },
        wallet: {
          name: "Digital Wallet",
          desc: "محفظة أورانج/فودافون/إتصالات/وي",
        },
        instructionsTitle: "تعليمات الدفع",
        instruction1: "قم بتحويل مبلغ",
        instruction1b: "جنيه إلى الرقم التالي:",
        instruction2: "احتفظ بإيصال التحويل (Screenshot)",
        instruction3: "قم برفع صورة الإيصال في الخطوة التالية",
        instruction4: "سيتم مراجعة طلبك خلال 24 ساعة",
        instruction5: "يجب دفع المبلغ كاملاً عن طريق التحويل",
        instructionPickup1: "قم بتحويل المبلغ كاملاً قبل الاستلام",
        instructionPickup2: "احتفظ بإيصال التحويل (Screenshot)",
        instructionPickup3: "قم برفع صورة الإيصال في الخطوة التالية",
        instructionPickup4: "سنتواصل معك عندما يكون الطلب جاهزاً",
        instructionPickup5: "قدم إيصال التحويل عند استلام الطلب",
        instaPayNumber: "01678900000",
        walletNumber: "01006611664",
        instaPayLink: "التحويل عبر رابط InstaPay",
        instaPayLinkDesc: "اضغط لفتح تطبيق InstaPay مباشرة",
        orText: "أو",
        transferManually: "حول يدوياً إلى:",
        note: "ملحوظة مهمة:",
        noteText: "بعد إتمام التحويل، لديك",
        noteText2: "لإكمال الطلب قبل إلغاء الحجز",
        notePickup: "يمكنك المتابعة مباشرة للتأكيد",
        backBtn: "رجوع",
        nextBtn: "التالي: رفع الإيصال",
        nextBtnPickup: "التالي: رفع الإيصال",
      },
      step3: {
        title: "رفع إيصال التحويل",
        titlePickup: "المراجعة النهائية والتأكيد",
        uploadTitle: "اضغط لرفع صورة الإيصال",
        uploadDesc: "PNG, JPG أو JPEG (حد أقصى 5MB)",
        uploadOptional: "(اختياري لطلبات الاستلام من الفرع)",
        reviewTitle: "مراجعة نهائية",
        name: "الاسم:",
        phone: "الهاتف:",
        email: "البريد الإلكتروني:",
        city: "المدينة:",
        state: "المحافظة:",
        address: "العنوان:",
        paymentMethod: "طريقة الدفع:",
        amountPaid: "المبلغ المدفوع:",
        deliveryType: "طريقة التوصيل:",
        branch: "فرع الاستلام:",
        shippingFee: "مصاريف الشحن:",
        backBtn: "رجوع",
        submitBtn: "تأكيد وإتمام الطلب",
        submitting: "جاري إتمام الطلب...",
      },
      success: {
        title: "تم إرسال طلبك بنجاح!",
        message: "سيتم مراجعة طلبك والتواصل معك قريباً",
      },
      errors: {
        nameRequired: "الاسم مطلوب",
        phoneRequired: "رقم الهاتف مطلوب",
        emailRequired: "البريد الإلكتروني مطلوب",
        addressRequired: "العنوان مطلوب",
        cityRequired: "المدينة مطلوبة",
        stateRequired: "المحافظة مطلوبة",
        imageRequired: "من فضلك ارفع صورة التحويل أولاً",
        imageSize: "حجم الصورة كبير جداً! الحد الأقصى 5MB",
        promoInvalid: "كود الخصم غير صالح",
        promoApplied: "تم تطبيق كود الخصم بنجاح!",
      },
      emptyCart: "عربة التسوق فارغة",
      emptyCartMsg: "من فضلك أضف منتجات للسلة أولاً",
      goToShop: "الذهاب للمتجر",
      color: "اللون",
      size: "المقاس",
      withoutBox: "بدون علبة",
      qty: "الكمية",
      default: "افتراضي",
    },
  };

  const t = content[lang] || content.EN;

  // ✅ FIX #2: Calculate total correctly with shipping BEFORE promo discount
  const shipping = deliveryType === "delivery" ? selectedStateDeliveryFees : 0;
  const totalBeforeDiscount = subtotal + shipping;
  const finalTotal = totalBeforeDiscount - discountAmount;
  const depositAmount = finalTotal;
  const depositPercentage = 100;

  // Initialize map when step changes to 1 and delivery type is 'delivery'
  useEffect(() => {
    if (
      step === 1 &&
      deliveryType === "delivery" &&
      window.L &&
      !mapInitialized
    ) {
      if (!authContext?.user || useNewAddress) {
        setTimeout(initializeMap, 150);
      }
    }

    return () => {
      if (
        leafletMapRef.current &&
        (step !== 1 || deliveryType !== "delivery")
      ) {
        try {
          leafletMapRef.current.remove();
          leafletMapRef.current = null;
          markerRef.current = null;
          setMapInitialized(false);
        } catch (error) {
          console.error("Map cleanup error:", error);
        }
      }
    };
  }, [step, deliveryType, mapInitialized, authContext?.user, useNewAddress]);

  // Initialize Leaflet Map
  const initializeMap = () => {
    if (!window.L || mapInitialized) return;

    const mapElement = document.getElementById("inline-leaflet-map");
    if (!mapElement) {
      console.warn("Map element not found, retrying...");
      setTimeout(initializeMap, 200);
      return;
    }

    if (leafletMapRef.current) {
      try {
        leafletMapRef.current.remove();
      } catch (error) {
        console.error("Error removing old map:", error);
      }
      leafletMapRef.current = null;
    }

    // باقي الكود الموجود عندك زي ما هو...
    const map = window.L.map("inline-leaflet-map", {
      center: [selectedLocation.lat, selectedLocation.lng],
      zoom: 15,
      zoomControl: true,
    });

    window.L.tileLayer(
      "https://{s}.basemaps.cartocdn.com/dark_all/{z}/{x}/{y}{r}.png",
      {
        attribution: "©OpenStreetMap, ©CartoDB",
        maxZoom: 19,
        subdomains: "abcd",
      },
    ).addTo(map);

    const goldIcon = window.L.divIcon({
      className: "custom-leaflet-marker",
      html: `<div style="
      width: 40px;
      height: 40px;
      background: linear-gradient(135deg, #f6d365 0%, #fda085 100%);
      border-radius: 50% 50% 50% 0;
      transform: rotate(-45deg);
      border: 3px solid white;
      box-shadow: 0 8px 24px rgba(246, 211, 101, 0.6);
      position: relative;
    ">
      <div style="
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%) rotate(45deg);
        font-size: 20px;
      ">📍</div>
    </div>`,
      iconSize: [40, 40],
      iconAnchor: [20, 40],
    });

    const marker = window.L.marker(
      [selectedLocation.lat, selectedLocation.lng],
      {
        icon: goldIcon,
        draggable: true,
      },
    ).addTo(map);

    markerRef.current = marker;
    leafletMapRef.current = map;
    setMapInitialized(true);

    marker.on("dragend", () => {
      const position = marker.getLatLng();
      reverseGeocode(position.lat, position.lng);
    });

    map.on("click", (e) => {
      marker.setLatLng(e.latlng);
      reverseGeocode(e.latlng.lat, e.latlng.lng);
    });

    reverseGeocode(selectedLocation.lat, selectedLocation.lng);
  };

  // ✅ FIX #5: Update shipping fee when selecting from map
  const reverseGeocode = async (lat, lng) => {
    try {
      const response = await fetch(
        `https://nominatim.openstreetmap.org/reverse?format=json&lat=${lat}&lon=${lng}&accept-language=en`,
      );
      const data = await response.json();

      if (data && data.address) {
        const city =
          data.address.city || data.address.town || data.address.village || "";
        const stateFromMap = data.address.state || "";
        const street = data.display_name || "";

        const matchedState = findStateByName(stateFromMap);

        const stateToSet = matchedState
          ? lang === "AR"
            ? matchedState.nameAr
            : matchedState.nameEn
          : stateFromMap;

        setSelectedLocation({ lat, lng });
        setFormData((prev) => ({
          ...prev,
          address: street,
          city: city || prev.city,
          state: stateToSet,
          latitude: lat,
          longitude: lng,
        }));

        if (matchedState && deliveryType === "delivery") {
          setSelectedStateDeliveryFees(matchedState.deliveryFees);
          console.log(
            "🗺️ Map → State:",
            stateToSet,
            "Shipping:",
            matchedState.deliveryFees,
          );
        }
      }
    } catch (error) {
      console.error("Reverse geocoding error:", error);
    }
  };

  const getCurrentLocation = () => {
    if (!navigator.geolocation) {
      toast.error(
        lang === "AR"
          ? "المتصفح لا يدعم تحديد الموقع"
          : "Geolocation is not supported",
      );
      return;
    }

    toast.info(t.step1.currentLocation + "...");

    navigator.geolocation.getCurrentPosition(
      (position) => {
        const { latitude, longitude } = position.coords;
        setSelectedLocation({ lat: latitude, lng: longitude });

        if (leafletMapRef.current && markerRef.current) {
          const newPos = [latitude, longitude];
          leafletMapRef.current.setView(newPos, 17);
          markerRef.current.setLatLng(newPos);
          reverseGeocode(latitude, longitude);
        }
        toast.success(
          lang === "AR" ? "✅ تم تحديد موقعك" : "✅ Location detected",
        );
      },
      (error) => {
        console.error("Geolocation error:", error);
        toast.error(
          lang === "AR" ? "فشل تحديد موقعك" : "Failed to get your location",
        );
      },
    );
  };

  const handleMapSearch = async () => {
    if (!searchQuery.trim()) return;

    setIsSearching(true);
    try {
      const response = await fetch(
        `https://nominatim.openstreetmap.org/search?format=json&q=${encodeURIComponent(searchQuery)}&limit=1&accept-language=${lang === "AR" ? "ar" : "en"}&countrycodes=eg`,
      );
      const data = await response.json();

      if (data && data[0]) {
        const { lat, lon } = data[0];
        const newLat = parseFloat(lat);
        const newLng = parseFloat(lon);

        setSelectedLocation({ lat: newLat, lng: newLng });

        if (leafletMapRef.current && markerRef.current) {
          leafletMapRef.current.setView([newLat, newLng], 17);
          markerRef.current.setLatLng([newLat, newLng]);
          reverseGeocode(newLat, newLng);
        }
        toast.success(
          lang === "AR" ? "تم العثور على الموقع" : "Location found",
        );
      } else {
        toast.error(
          lang === "AR" ? "لم يتم العثور على الموقع" : "Location not found",
        );
      }
    } catch (error) {
      console.error("Search error:", error);
      toast.error(lang === "AR" ? "خطأ في البحث" : "Search error");
    } finally {
      setIsSearching(false);
    }
  };

  useEffect(() => {
    const fetchAddresses = async () => {
      if (!authContext?.user?.id) {
        if (deliveryType === "delivery") {
          setUseNewAddress(true);
        }
        return;
      }

      try {
        setIsLoadingAddresses(true);
        const response = await fetchUserAddresses(authContext.user.id);

        if (response.status === HttpStatusCode.Ok) {
          setSavedAddresses(response.data || []);

          const defaultAddress = response.data.find((addr) => addr.isDefault);
          if (defaultAddress) {
            setSelectedAddressId(defaultAddress.id);
            fillFormWithAddress(defaultAddress);
          } else if (response.data.length > 0) {
            setSelectedAddressId(response.data[0].id);
            fillFormWithAddress(response.data[0]);
          } else {
            setUseNewAddress(true);
          }
        }
      } catch (error) {
        console.error("Error fetching addresses:", error);
        setUseNewAddress(true);
      } finally {
        setIsLoadingAddresses(false);
      }
    };

    fetchAddresses();
  }, [authContext?.user?.id]);

  const findStateByName = (stateName) => {
    if (!stateName) return null;
    const normalizedInput = stateName.trim().toLowerCase();
    return states.find(
      (s) =>
        s.nameEn.toLowerCase() === normalizedInput ||
        s.nameAr.toLowerCase() === normalizedInput ||
        s.nameEn.toLowerCase().includes(normalizedInput) ||
        normalizedInput.includes(s.nameEn.toLowerCase()),
    );
  };

  const fillFormWithAddress = (address) => {
    const matchedState = findStateByName(address.state);
    const stateToSet = matchedState
      ? lang === "AR"
        ? matchedState.nameAr
        : matchedState.nameEn
      : address.state;

    setFormData((prev) => ({
      ...prev,
      fullName:
        `${authContext.user?.firstName || ""} ${authContext.user?.lastName || ""}`.trim(),
      phone: address.phoneNumber || authContext.user?.mobile || "",
      email: authContext.user?.email || "",
      address: address.street || "",
      city: address.city || "",
      state: stateToSet,
    }));

    if (matchedState && deliveryType === "delivery") {
      setSelectedStateDeliveryFees(matchedState.deliveryFees);
      console.log(
        "💾 Saved Address → State:",
        stateToSet,
        "Shipping:",
        matchedState.deliveryFees,
      );
    }
  };

  const handleAddressSelect = (addressId) => {
    setSelectedAddressId(addressId);
    setUseNewAddress(false);

    const selectedAddress = savedAddresses.find(
      (addr) => addr.id === addressId,
    );
    if (selectedAddress) {
      fillFormWithAddress(selectedAddress);
    }
  };

  const handleUseNewAddress = () => {
    setUseNewAddress(true);
    setSelectedAddressId(null);
    setFormData((prev) => ({
      ...prev,
      fullName:
        `${authContext.user?.firstName || ""} ${authContext.user?.lastName || ""}`.trim(),
      phone: authContext.user?.mobile || "",
      email: authContext.user?.email || "",
      address: "",
      city: "",
      state: "",
    }));

    if (deliveryType === "delivery" && window.L && !mapInitialized) {
      setTimeout(initializeMap, 100);
    }
  };

  const handleDeliveryTypeChange = (type) => {
    setDeliveryType(type);
    if (type === "pickup") {
      setFormData((prev) => ({
        ...prev,
        address: "",
        city: "",
        state: "",
        paymentMethod: "INSTAPAY",
      }));
      setSelectedStateDeliveryFees(0);
      if (leafletMapRef.current) {
        leafletMapRef.current.remove();
        leafletMapRef.current = null;
        setMapInitialized(false);
      }
    } else if (type === "delivery") {
      setFormData((prev) => ({
        ...prev,
        paymentMethod: "INSTAPAY",
      }));

      const selectedAddress = savedAddresses.find(
        (addr) => addr.id === selectedAddressId,
      );
      if (selectedAddress) {
        fillFormWithAddress(selectedAddress);
      }
      if (
        window.L &&
        !mapInitialized &&
        (!authContext?.user || useNewAddress)
      ) {
        setTimeout(initializeMap, 100);
      }
    }
  };

  const handleBranchSelect = (branch) => {
    setSelectedBranch(branch);
  };

  // ✅ FIX #3: Promo code validation with shipping included
  const handleApplyPromo = async () => {
    if (!promoCode.trim()) {
      setPromoError(
        lang === "AR" ? "من فضلك أدخل كود الخصم" : "Please enter a promo code",
      );
      return;
    }

    setIsApplyingPromo(true);
    setPromoError("");
    setPromoSuccess("");

    try {
      // Include shipping in promo validation
      const totalWithShipping = subtotal + shipping;
      const response = await OrderApiService.validatePromoCode(
        promoCode.trim(),
        totalWithShipping,
      );

      if (response.status !== HttpStatusCode.Ok) {
        if (!response.isValid) {
          if (response.message.includes("Minimum order amount required")) {
            const minAmount = response.message.split(":")[1].trim();
            setPromoError(
              lang === "AR"
                ? `الحد الأدنى للطلب لتطبيق هذا الكود هو ${minAmount} ج.م`
                : `Minimum order amount to apply this code is EGP ${minAmount}`,
            );
          } else {
            setPromoError(response.message);
          }
          return;
        }
      }

      setDiscountAmount(response.discountAmount);
      setAppliedPromo(promoCode.toUpperCase());
      setPromoSuccess(t.errors.promoApplied);
    } catch (error) {
      console.error("Error applying promo:", error);
      setPromoError(
        lang === "AR" ? "خطأ في تطبيق الكود" : "Error applying promo code",
      );
      toast.error(
        lang === "AR"
          ? "❌ حدث خطأ أثناء تطبيق الكود"
          : "❌ Error applying promo code",
      );
    } finally {
      setIsApplyingPromo(false);
    }
  };

  const handleRemovePromo = () => {
    setAppliedPromo(null);
    setPromoCode("");
    setDiscountAmount(0);
    setPromoError("");
    setPromoSuccess("");
    toast.info(lang === "AR" ? "تم إزالة كود الخصم" : "Promo code removed");
  };

  useEffect(() => {
    const timer = setInterval(() => {
      if (timeLeft <= 0) {
        setIsExpired(true);
        return;
      }
      setTimeLeft((prev) => prev - 1);
    }, 1000);
    return () => clearInterval(timer);
  }, [timeLeft]);

  const formatTime = (seconds) => {
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${mins.toString().padStart(2, "0")}:${secs.toString().padStart(2, "0")}`;
  };

  const formatCurrency = (amount) => {
    if (typeof amount !== "number")
      return lang === "AR" ? "0.00 ج.م" : "EGP 0.00";
    return lang === "AR"
      ? `${amount.toFixed(2)} ج.م`
      : `EGP ${amount.toFixed(2)}`;
  };

  const getProductName = (product) => {
    if (!product) return "";
    return lang === "AR" && product.nameAr ? product.nameAr : product.nameEn;
  };

  const getLocalizedName = (item) => {
    if (!item) return "";
    return lang === "AR" && item.nameAr ? item.nameAr : item.nameEn;
  };

  const calculateItemPrice = (price, isWithoutBox) => {
    const basePrice = price || 0;
    return isWithoutBox ? Math.max(0, basePrice - 100) : basePrice;
  };

  const calculateItemTotal = (price, quantity, isWithoutBox) => {
    const itemPrice = calculateItemPrice(price, isWithoutBox);
    return itemPrice * quantity || 0;
  };

  const getVariantInfo = (item) => {
    const parts = [];
    if (item.variant.color?.id) {
      const colorName = getLocalizedName(item.variant.color);
      parts.push(`${t.color}: ${colorName}`);
    }
    if (item.variant.size?.id) {
      const sizeName = getLocalizedName(item.variant.size);
      parts.push(`${t.size}: ${sizeName}`);
    }
    return parts.join(" • ");
  };

  const validateForm = () => {
    const newErrors = {};

    if (!formData.fullName.trim()) newErrors.fullName = t.errors.nameRequired;
    if (!formData.phone.trim()) newErrors.phone = t.errors.phoneRequired;

    if (!authContext?.user && !formData.email?.trim()) {
      newErrors.email = t.errors.emailRequired;
    }

    if (deliveryType === "delivery") {
      if (!formData.address.trim())
        newErrors.address = t.errors.addressRequired;
      if (!formData.city.trim()) newErrors.city = t.errors.cityRequired;
      if (!formData.state.trim()) newErrors.state = t.errors.stateRequired;
    } else if (deliveryType === "pickup") {
      if (!selectedBranch) {
        toast.error(t.branches.selectBranchError);
        return false;
      }
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleImageUpload = async (e) => {
    const file = e.target.files[0];
    if (file) {
      if (file.size > 5 * 1024 * 1024) {
        toast.error(t.errors.imageSize);
        return;
      }

      try {
        const compressedFile = await compressImage(file, 800, 0.7);

        setUploadedImage(compressedFile);
        const reader = new FileReader();
        reader.onloadend = () => {
          setImagePreview(reader.result);
        };
        reader.readAsDataURL(compressedFile);
      } catch (error) {
        console.error("Error compressing image:", error);
        setUploadedImage(file);
        const reader = new FileReader();
        reader.onloadend = () => {
          setImagePreview(reader.result);
        };
        reader.readAsDataURL(file);
      }
    }
  };

  const removeImage = () => {
    setUploadedImage(null);
    setImagePreview(null);
    if (fileInputRef.current) {
      fileInputRef.current.value = "";
    }
  };

  const goToNextStep = () => {
    if (step === 1) {
      if (validateForm()) {
        setStep(2);
      }
    } else if (step === 2) {
      setStep(3);
    }
  };

  const handleSubmitOrder = async () => {
    if (!uploadedImage) {
      toast.error(t.errors.imageRequired);
      return;
    }

    setIsSubmitting(true);

    try {
      const checkoutData = {
        email: authContext?.user?.email || formData.email || "",
        phone: formData.phone,
        paymentMethod: formData.paymentMethod,
        pickFromStore: deliveryType === "pickup",
        orderNotes: formData.notes || null,
        transactionId: `TRX-${Date.now()}-${Math.random().toString(36).substr(2, 9)}`,
        promoCode: appliedPromo || null,
      };

      if (deliveryType === "delivery") {
        if (selectedAddressId && !useNewAddress) {
          checkoutData.userAddressId = selectedAddressId;
        } else {
          checkoutData.shippingAddress = {
            fullName: formData.fullName,
            street: formData.address,
            city: formData.city,
            state: formData.state,
            country: "Egypt",
            phoneNumber: formData.phone,
            latitude: formData.latitude,
            longitude: formData.longitude,
          };
        }
      } else {
        checkoutData.storeAddress =
          lang === "AR" ? selectedBranch.address.AR : selectedBranch.address.EN;

        checkoutData.shippingAddress = {
          fullName: formData.fullName,
          street:
            lang === "AR"
              ? selectedBranch.address.AR
              : selectedBranch.address.EN,
          city: lang === "AR" ? selectedBranch.name.AR : selectedBranch.name.EN,
          state: "Cairo",
          country: "Egypt",
          phoneNumber: formData.phone,
        };
      }

      checkoutData.paymentProofFile = uploadedImage;

      const response = await OrderApiService.completeCheckout(
        checkoutId,
        checkoutData,
      );

      if (response && response.orderId) {
        setShowSuccess(true);
        clearCart();
        setShowSuccess(false);
        navigate("/", { replace: true });
      } else {
        toast.error(
          lang === "AR"
            ? "حدث خطأ أثناء إتمام الطلب. حاول مرة أخرى."
            : "An error occurred while completing the order. Please try again.",
        );
      }
    } catch (error) {
      console.error("Error completing checkout:", error);

      const errorMessage =
        error.response?.data?.message ||
        (lang === "AR"
          ? "حدث خطأ أثناء إتمام الطلب. حاول مرة أخرى."
          : "An error occurred while completing the order. Please try again.");

      toast.error(errorMessage);
    } finally {
      setIsSubmitting(false);
    }
  };

  const getTimerColor = () => {
    if (timeLeft > 180) return "#10b981";
    if (timeLeft > 60) return "#f59e0b";
    return "#ef4444";
  };

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [step]);

  useEffect(() => {
    const fetchStates = async () => {
      try {
        setIsLoadingStates(true);
        const response = await StatesApiService.getActiveStates();
        setStates(response);
      } catch (error) {
        console.error("Error fetching states:", error);
        toast.error(
          lang === "AR" ? "فشل تحميل المحافظات" : "Failed to load states",
        );
      } finally {
        setIsLoadingStates(false);
      }
    };

    fetchStates();
  }, [lang]);

  const calculateShippingFee = (stateName) => {
    if (!stateName || deliveryType === "pickup") {
      return 0;
    }

    const selectedState = findStateByName(stateName);
    return selectedState ? selectedState.deliveryFees : 50;
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));

    if (name === "state" && deliveryType === "delivery") {
      const matchedState = findStateByName(value);
      const shippingFee = matchedState ? matchedState.deliveryFees : 50;
      setSelectedStateDeliveryFees(shippingFee);
    }

    if (errors[name]) {
      setErrors((prev) => ({ ...prev, [name]: "" }));
    }
  };

  if (!cartItems || cartItems.length === 0) {
    return (
      <div className={`checkout-page expired ${lang === "AR" ? "rtl" : "ltr"}`}>
        <div className="expired-container">
          <div className="expired-icon">
            <Package size={80} />
          </div>
          <h2>{t.emptyCart}</h2>
          <p>{t.emptyCartMsg}</p>
          <button className="retry-btn" onClick={() => navigate("/")}>
            {t.goToShop}
          </button>
        </div>
      </div>
    );
  }

  if (isExpired) {
    return (
      <div className={`checkout-page expired ${lang === "AR" ? "rtl" : "ltr"}`}>
        <div className="expired-container">
          <div className="expired-icon">
            <Clock size={80} />
          </div>
          <h2>{t.timer.expired}</h2>
          <p>{t.timer.expiredMsg}</p>
          <button className="retry-btn" onClick={() => navigate("/")}>
            {t.timer.retry}
          </button>
        </div>
      </div>
    );
  }

  return (
    <div
      className={`checkout-page ${lang === "AR" ? "rtl" : "ltr"}`}
      style={{ "--timer-color": getTimerColor() }}
    >
      <div className="timer-bar">
        <div className="timer-content">
          <Clock size={window.innerWidth <= 480 ? 16 : 20} />
          <span className="timer-label">{t.timer.label}</span>
          <span className="timer-value">{formatTime(timeLeft)}</span>
        </div>
        <div
          className="timer-progress"
          style={{ width: `${(timeLeft / 300) * 100}%` }}
        />
      </div>

      <div className="checkout-container">
        <div className="order-summary-sidebar">
          <div className="summary-card">
            <h3 className="summary-title">
              <Package size={24} />
              {t.summary.title}
            </h3>

            <div className="summary-items">
              {cartItems.map((item, idx) => {
                const price = item.variant.discountPrice || item.variant.price;
                const displayPrice = calculateItemPrice(price, item.withoutBox);
                const itemTotal = calculateItemTotal(
                  price,
                  item.quantity,
                  item.withoutBox,
                );

                return (
                  <div
                    key={`${item.product.id}-${item.variant.id}-${item.withoutBox ? "without" : "with"}-${idx}`}
                    className="summary-item"
                  >
                    <div className="summary-item-image-wrapper">
                      <img
                        src={item.product.images[0]?.image_url}
                        alt={getProductName(item.product)}
                        className="summary-item-image"
                        loading="lazy"
                      />
                      {item.withoutBox && (
                        <span className="summary-without-box-badge">
                          📦 {t.withoutBox}
                        </span>
                      )}
                    </div>
                    <div className="summary-item-details">
                      <span className="summary-item-name">
                        {getProductName(item.product)}
                      </span>
                      <span className="summary-item-variant">
                        {getVariantInfo(item)}
                      </span>
                      <span className="summary-item-qty">
                        {t.qty}: {item.quantity} ×{" "}
                        {formatCurrency(displayPrice)}
                      </span>
                    </div>
                    <span className="summary-item-price">
                      {formatCurrency(itemTotal)}
                    </span>
                  </div>
                );
              })}
            </div>

            <div className="summary-divider" />

            <div className="summary-totals">
              <div className="summary-row">
                <span>{t.summary.subtotal}</span>
                <span>{formatCurrency(subtotal)}</span>
              </div>

              <div className="summary-row">
                <span>{t.summary.shipping}</span>
                <span className={shipping === 0 ? "free" : ""}>
                  {shipping === 0 ? t.summary.free : formatCurrency(shipping)}
                </span>
              </div>

              {discountAmount > 0 && (
                <div className="summary-row discount">
                  <span>{t.summary.discount}</span>
                  <span>-{formatCurrency(discountAmount)}</span>
                </div>
              )}

              <div className="summary-divider-thin" />

              <div className="summary-row total">
                <span>{t.summary.total}</span>
                <span>{formatCurrency(finalTotal)}</span>
              </div>
            </div>

            <div className="promo-code-section">
              {!appliedPromo ? (
                <>
                  <div className="promo-input-wrapper">
                    <input
                      type="text"
                      className="promo-input"
                      placeholder={t.summary.promoPlaceholder}
                      value={promoCode}
                      onChange={(e) => setPromoCode(e.target.value)}
                      onKeyPress={(e) =>
                        e.key === "Enter" && handleApplyPromo()
                      }
                    />
                    <button
                      className="promo-apply-btn"
                      onClick={handleApplyPromo}
                      disabled={isApplyingPromo || !promoCode.trim()}
                    >
                      {isApplyingPromo ? (
                        <div className="spinner-small" />
                      ) : (
                        t.summary.apply
                      )}
                    </button>
                  </div>
                  {promoError && (
                    <div className="promo-error">{promoError}</div>
                  )}
                  {promoSuccess && (
                    <div className="promo-success">{promoSuccess}</div>
                  )}
                </>
              ) : (
                <div className="promo-applied">
                  <div className="promo-applied-content">
                    <Tag size={16} />
                    <span>
                      {t.summary.applied} <strong>{appliedPromo}</strong>
                    </span>
                  </div>
                  <button
                    className="promo-remove-btn"
                    onClick={handleRemovePromo}
                  >
                    <X size={16} />
                  </button>
                </div>
              )}
            </div>

            <div className="deposit-notice">
              <CreditCard size={20} />
              <div>
                <div className="deposit-label">{t.summary.depositLabel}</div>
                <div className="deposit-amount">
                  {formatCurrency(depositAmount)}
                </div>
                <div className="deposit-desc">{t.summary.depositDesc}</div>
              </div>
            </div>
          </div>
        </div>

        <div className="checkout-main">
          <div className="progress-steps">
            <div
              className={`step ${step >= 1 ? "active" : ""} ${step > 1 ? "completed" : ""}`}
            >
              <div className="step-circle">
                {step > 1 ? <CheckCircle size={20} /> : <span>1</span>}
              </div>
              <span className="step-label">{t.steps.info}</span>
            </div>
            <div className="step-line" />
            <div
              className={`step ${step >= 2 ? "active" : ""} ${step > 2 ? "completed" : ""}`}
            >
              <div className="step-circle">
                {step > 2 ? <CheckCircle size={20} /> : <span>2</span>}
              </div>
              <span className="step-label">{t.steps.payment}</span>
            </div>
            <div className="step-line" />
            <div className={`step ${step >= 3 ? "active" : ""}`}>
              <div className="step-circle">
                <span>3</span>
              </div>
              <span className="step-label">{t.steps.confirm}</span>
            </div>
          </div>

          {step === 1 && (
            <div className="step-content">
              <h2 className="step-title">{t.step1.title}</h2>

              <div className="delivery-type-section">
                <h3 className="delivery-type-title">
                  {t.deliveryOptions.title}
                </h3>
                <div className="delivery-options-grid">
                  <div
                    className={`delivery-option ${deliveryType === "delivery" ? "selected" : ""}`}
                    onClick={() => handleDeliveryTypeChange("delivery")}
                  >
                    <div className="delivery-option-icon">
                      <Package size={32} />
                    </div>
                    <div className="delivery-option-content">
                      <h4>{t.deliveryOptions.delivery.title}</h4>
                      <p>{t.deliveryOptions.delivery.desc}</p>
                    </div>
                    <div className="delivery-option-radio">
                      <div
                        className={`radio-dot ${deliveryType === "delivery" ? "active" : ""}`}
                      />
                    </div>
                  </div>

                  <div
                    className={`delivery-option ${deliveryType === "pickup" ? "selected" : ""}`}
                    onClick={() => handleDeliveryTypeChange("pickup")}
                  >
                    <div className="delivery-option-icon">
                      <Store size={32} />
                    </div>
                    <div className="delivery-option-content">
                      <h4>{t.deliveryOptions.pickup.title}</h4>
                      <p>{t.deliveryOptions.pickup.desc}</p>
                    </div>
                    <div className="delivery-option-radio">
                      <div
                        className={`radio-dot ${deliveryType === "pickup" ? "active" : ""}`}
                      />
                    </div>
                  </div>
                </div>
              </div>

              <div className="personal-info-section">
                <div className="form-grid">
                  <div className="form-group full-width">
                    <label>
                      <User size={18} />
                      {t.step1.fullName}
                    </label>
                    <input
                      type="text"
                      name="fullName"
                      value={formData.fullName}
                      onChange={handleInputChange}
                      placeholder={t.step1.fullNamePlaceholder}
                      className={errors.fullName ? "error" : ""}
                    />
                    {errors.fullName && (
                      <span className="error-msg">{errors.fullName}</span>
                    )}
                  </div>

                  <div className="form-group">
                    <label>
                      <Phone size={18} />
                      {t.step1.phone}
                    </label>
                    <input
                      type="tel"
                      name="phone"
                      value={formData.phone}
                      onChange={handleInputChange}
                      placeholder={t.step1.phonePlaceholder}
                      className={errors.phone ? "error" : ""}
                    />
                    {errors.phone && (
                      <span className="error-msg">{errors.phone}</span>
                    )}
                  </div>

                  {!authContext?.user && (
                    <div className="form-group">
                      <label>
                        <User size={18} />
                        {t.step1.email}
                      </label>
                      <input
                        type="email"
                        name="email"
                        value={formData.email || ""}
                        onChange={handleInputChange}
                        placeholder={t.step1.emailPlaceholder}
                        className={errors.email ? "error" : ""}
                      />
                      {errors.email && (
                        <span className="error-msg">{errors.email}</span>
                      )}
                    </div>
                  )}
                </div>
              </div>

              {deliveryType === "delivery" && (
                <>
                  {isLoadingAddresses ? (
                    <div className="loading-addresses-section">
                      <div className="spinner" />
                      <p>{t.step1.loadingAddresses}</p>
                    </div>
                  ) : (
                    savedAddresses.length > 0 &&
                    authContext?.user && (
                      <div className="saved-addresses-section">
                        <h3 className="addresses-section-title">
                          {t.step1.savedAddresses}
                        </h3>
                        <div className="saved-addresses-grid">
                          {savedAddresses.map((address) => (
                            <div
                              key={address.id}
                              className={`saved-address-card ${selectedAddressId === address.id ? "selected" : ""}`}
                              onClick={() => handleAddressSelect(address.id)}
                            >
                              <div className="address-radio">
                                <div
                                  className={`radio-dot ${selectedAddressId === address.id ? "active" : ""}`}
                                />
                              </div>
                              <div className="address-info">
                                <div className="address-header">
                                  <MapPin size={18} />
                                  {address.isDefault && (
                                    <span className="default-badge-small">
                                      {t.default}
                                    </span>
                                  )}
                                </div>
                                <p className="address-street">
                                  {address.street}
                                </p>
                                <p className="address-city">
                                  {address.city}, {address.state}
                                </p>
                                {address.phoneNumber && (
                                  <p className="address-phone">
                                    <Phone size={14} />
                                    {address.phoneNumber}
                                  </p>
                                )}
                              </div>
                            </div>
                          ))}

                          <div
                            className={`saved-address-card new-address ${useNewAddress ? "selected" : ""}`}
                            onClick={handleUseNewAddress}
                          >
                            <div className="address-radio">
                              <div
                                className={`radio-dot ${useNewAddress ? "active" : ""}`}
                              />
                            </div>
                            <div className="address-info new-address-content">
                              <Plus size={24} />
                              <p>{t.step1.useNewAddress}</p>
                            </div>
                          </div>
                        </div>
                      </div>
                    )
                  )}

                  {(!authContext?.user || useNewAddress) && (
                    <div className="inline-map-section">
                      <div className="map-section-header">
                        <h3 className="map-section-title">
                          <MapPin size={20} />
                          {t.step1.mapTitle}
                        </h3>
                        <p className="map-section-subtitle">
                          {t.step1.mapInstruction}
                        </p>
                      </div>

                      <div className="inline-map-controls">
                        <div className="inline-map-search">
                          <Search size={18} />
                          <input
                            type="text"
                            placeholder={t.step1.search}
                            value={searchQuery}
                            onChange={(e) => setSearchQuery(e.target.value)}
                            onKeyPress={(e) =>
                              e.key === "Enter" && handleMapSearch()
                            }
                          />
                          <button
                            onClick={handleMapSearch}
                            disabled={isSearching}
                          >
                            {t.step1.searchBtn}
                          </button>
                        </div>
                        <button
                          className="inline-map-current-location"
                          onClick={getCurrentLocation}
                        >
                          <Navigation size={18} />
                          {t.step1.currentLocation}
                        </button>
                      </div>

                      <div className="inline-map-container">
                        <div id="inline-leaflet-map"></div>
                      </div>
                    </div>
                  )}

                  <div className="address-form-section">
                    <h3 className="address-form-title">
                      {!authContext?.user
                        ? t.step1.useNewAddress
                        : useNewAddress || savedAddresses.length === 0
                          ? t.step1.useNewAddress
                          : t.step1.selectAddress}
                    </h3>

                    <div className="form-grid">
                      <div className="form-group">
                        <label>
                          <MapPin size={18} />
                          {t.step1.city}
                        </label>
                        <input
                          type="text"
                          name="city"
                          value={formData.city}
                          onChange={handleInputChange}
                          placeholder={t.step1.cityPlaceholder}
                          className={errors.city ? "error" : ""}
                        />
                        {errors.city && (
                          <span className="error-msg">{errors.city}</span>
                        )}
                      </div>

                      <div className="form-group">
                        <label>
                          <MapPin size={18} />
                          {t.step1.state}
                        </label>
                        <div className="select-wrapper-glass">
                          <select
                            name="state"
                            value={formData.state}
                            onChange={handleInputChange}
                            className={`form-input-glass select-input ${errors.state ? "error" : ""}`}
                            disabled={isLoadingStates}
                          >
                            <option value="">
                              {isLoadingStates
                                ? lang === "AR"
                                  ? "جاري التحميل..."
                                  : "Loading..."
                                : t.step1.selectState}
                            </option>
                            {states.map((state) => (
                              <option
                                key={state.id}
                                value={
                                  lang === "EN" ? state.nameEn : state.nameAr
                                }
                              >
                                {lang === "EN" ? state.nameEn : state.nameAr}
                              </option>
                            ))}
                          </select>
                          <ChevronDown className="select-arrow" size={18} />
                        </div>
                        {errors.state && (
                          <span className="error-msg">{errors.state}</span>
                        )}
                      </div>

                      <div className="form-group full-width">
                        <label>
                          <MapPin size={18} />
                          {t.step1.address}
                        </label>
                        <textarea
                          name="address"
                          value={formData.address}
                          onChange={handleInputChange}
                          placeholder={t.step1.addressPlaceholder}
                          rows="3"
                          className={errors.address ? "error" : ""}
                        />
                        {errors.address && (
                          <span className="error-msg">{errors.address}</span>
                        )}
                      </div>
                    </div>
                  </div>
                </>
              )}

              {deliveryType === "pickup" && (
                <div className="branches-section">
                  <h3 className="branches-section-title">{t.branches.title}</h3>
                  <div className="branches-grid">
                    {branches.map((branch) => (
                      <div
                        key={branch.id}
                        className={`branch-card ${selectedBranch?.id === branch.id ? "selected" : ""}`}
                        onClick={() => handleBranchSelect(branch)}
                      >
                        <div className="branch-radio">
                          <div
                            className={`radio-dot ${selectedBranch?.id === branch.id ? "active" : ""}`}
                          />
                        </div>
                        <div className="branch-content">
                          <div className="branch-header">
                            <Store size={20} />
                            <h4>
                              {lang === "AR" ? branch.name.AR : branch.name.EN}
                            </h4>
                          </div>
                          <div className="branch-details">
                            <p className="branch-address">
                              <MapPin size={16} />
                              <span>
                                {lang === "AR"
                                  ? branch.address.AR
                                  : branch.address.EN}
                              </span>
                            </p>
                            <p className="branch-phone">
                              <Phone size={16} />
                              <span>{branch.phone}</span>
                            </p>
                            <p className="branch-hours">
                              <Clock size={16} />
                              <span>
                                {lang === "AR"
                                  ? branch.hours.AR
                                  : branch.hours.EN}
                              </span>
                            </p>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              )}

              <div className="form-group full-width notes-section">
                <label>{t.step1.notes}</label>
                <textarea
                  name="notes"
                  value={formData.notes}
                  onChange={handleInputChange}
                  placeholder={t.step1.notesPlaceholder}
                  rows="2"
                />
              </div>

              <button className="next-btn" onClick={goToNextStep}>
                {t.step1.nextBtn}
                <ArrowRight size={20} />
              </button>
            </div>
          )}

          {step === 2 && (
            <div className="step-content">
              <h2 className="step-title">{t.step2.title}</h2>

              <div className="payment-methods">
                <>
                  <div
                    className={`payment-method ${formData.paymentMethod === "INSTAPAY" ? "selected" : ""}`}
                    onClick={() =>
                      setFormData((prev) => ({
                        ...prev,
                        paymentMethod: "INSTAPAY",
                      }))
                    }
                  >
                    <QrCode size={32} />
                    <div>
                      <div className="method-name">{t.step2.instapay.name}</div>
                      <div className="method-desc">{t.step2.instapay.desc}</div>
                    </div>
                  </div>

                  <div
                    className={`payment-method ${formData.paymentMethod === "DIGITAL_WALLET" ? "selected" : ""}`}
                    onClick={() =>
                      setFormData((prev) => ({
                        ...prev,
                        paymentMethod: "DIGITAL_WALLET",
                      }))
                    }
                  >
                    <Smartphone size={32} />
                    <div>
                      <div className="method-name">{t.step2.wallet.name}</div>
                      <div className="method-desc">{t.step2.wallet.desc}</div>
                    </div>
                  </div>
                </>
              </div>

              <div className="payment-instructions">
                <div className="instruction-header">
                  <AlertCircle size={24} />
                  <h3>{t.step2.instructionsTitle}</h3>
                </div>

                <>
                  {formData.paymentMethod === "INSTAPAY" && (
                    <div className="instapay-transfer-section">
                      <a
                        href="https://ipn.eg/S/addmixstore/instapay/52sPTk"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="instapay-link-button"
                      >
                        <div className="instapay-link-content">
                          <QrCode size={24} />
                          <div>
                            <div className="instapay-link-title">
                              {t.step2.instaPayLink}
                            </div>
                            <div className="instapay-link-desc">
                              {t.step2.instaPayLinkDesc}
                            </div>
                          </div>
                        </div>
                        <ArrowRight
                          size={20}
                          className={lang === "AR" ? "rotate-180" : ""}
                        />
                      </a>
                    </div>
                  )}

                  {formData.paymentMethod === "DIGITAL_WALLET" && (
                    <div className="wallet-transfer-section">
                      {t.step2.instruction1}{" "}
                      <strong>{depositAmount.toFixed(2)}</strong>{" "}
                      {t.step2.instruction1b}
                      <div className="phone-number wallet-number">
                        {t.step2.walletNumber}
                      </div>
                    </div>
                  )}

                  <div className="additional-instructions">
                    <h4 className="additional-instructions-title">
                      {deliveryType === "delivery"
                        ? lang === "AR"
                          ? "خطوات إضافية:"
                          : "Additional Steps:"
                        : lang === "AR"
                          ? "خطوات الاستلام:"
                          : "Pickup Steps:"}
                    </h4>
                    <ol className="instruction-list secondary">
                      {deliveryType === "delivery" ? (
                        <>
                          <li>{t.step2.instruction2}</li>
                          <li>{t.step2.instruction3}</li>
                          <li>{t.step2.instruction4}</li>
                        </>
                      ) : (
                        <>
                          <li>{t.step2.instructionPickup2}</li>
                          <li>{t.step2.instructionPickup3}</li>
                          <li>{t.step2.instructionPickup4}</li>
                          <li>{t.step2.instructionPickup5}</li>
                        </>
                      )}
                    </ol>
                  </div>

                  <div className="payment-note">
                    <strong>{t.step2.note}</strong> {t.step2.noteText}{" "}
                    {formatTime(timeLeft)} {t.step2.noteText2}
                  </div>
                </>
              </div>

              <div className="step-actions">
                <button className="back-btn" onClick={() => setStep(1)}>
                  {t.step2.backBtn}
                </button>
                <button className="next-btn" onClick={goToNextStep}>
                  {deliveryType === "pickup"
                    ? t.step2.nextBtnPickup
                    : t.step2.nextBtn}
                  <ArrowRight size={20} />
                </button>
              </div>
            </div>
          )}

          {step === 3 && (
            <div className="step-content">
              <h2 className="step-title">
                {deliveryType === "pickup"
                  ? t.step3.titlePickup
                  : t.step3.title}
              </h2>

              <div className="upload-section">
                {!imagePreview ? (
                  <div
                    className="upload-area"
                    onClick={() => fileInputRef.current?.click()}
                  >
                    <div className="upload-icon">
                      <Image size={48} />
                    </div>
                    <h3>{t.step3.uploadTitle}</h3>
                    <p>{t.step3.uploadDesc}</p>
                    <input
                      ref={fileInputRef}
                      type="file"
                      accept="image/*"
                      onChange={handleImageUpload}
                      style={{ display: "none" }}
                    />
                  </div>
                ) : (
                  <div className="preview-area">
                    <button className="remove-image-btn" onClick={removeImage}>
                      <X size={20} />
                    </button>
                    <img
                      src={imagePreview}
                      alt="Payment proof"
                      className="preview-image"
                    />
                    <div className="preview-info">
                      <FileCheck size={20} />
                      <span>{uploadedImage?.name}</span>
                    </div>
                  </div>
                )}
              </div>

              <div className="final-review">
                <h3>{t.step3.reviewTitle}</h3>
                <div className="review-grid">
                  <div className="review-item">
                    <span className="review-label">{t.step3.name}</span>
                    <span className="review-value">{formData.fullName}</span>
                  </div>
                  <div className="review-item">
                    <span className="review-label">{t.step3.phone}</span>
                    <span className="review-value">{formData.phone}</span>
                  </div>

                  {deliveryType === "delivery" ? (
                    <>
                      <div className="review-item">
                        <span className="review-label">{t.step3.city}</span>
                        <span className="review-value">{formData.city}</span>
                      </div>
                      <div className="review-item">
                        <span className="review-label">{t.step3.state}</span>
                        <span className="review-value">{formData.state}</span>
                      </div>
                      <div className="review-item full">
                        <span className="review-label">{t.step3.address}</span>
                        <span className="review-value">{formData.address}</span>
                      </div>
                    </>
                  ) : (
                    <div className="review-item full">
                      <span className="review-label">{t.step3.branch}</span>
                      <span className="review-value">
                        {lang === "AR"
                          ? selectedBranch?.name.AR
                          : selectedBranch?.name.EN}
                      </span>
                    </div>
                  )}

                  <div className="review-item">
                    <span className="review-label">{t.step3.deliveryType}</span>
                    <span className="review-value">
                      {deliveryType === "delivery"
                        ? t.deliveryOptions.delivery.title
                        : t.deliveryOptions.pickup.title}
                    </span>
                  </div>

                  <div className="review-item">
                    <span className="review-label">
                      {t.step3.paymentMethod}
                    </span>
                    <span className="review-value">
                      {formData.paymentMethod === "CASH" && t.step2.cash.name}
                      {formData.paymentMethod === "INSTAPAY" &&
                        t.step2.instapay.name}
                      {formData.paymentMethod === "DIGITAL_WALLET" &&
                        t.step2.wallet.name}
                    </span>
                  </div>

                  {/* ✅ FIX #4: Show shipping fee in final review */}
                  {deliveryType === "delivery" && (
                    <>
                      <div className="review-item">
                        <span className="review-label">
                          {t.step3.shippingFee}
                        </span>
                        <span className="review-value">
                          {shipping === 0
                            ? lang === "AR"
                              ? "مجاناً"
                              : "Free"
                            : formatCurrency(shipping)}
                        </span>
                      </div>
                      <div className="review-item">
                        <span className="review-label">
                          {t.step3.amountPaid}
                        </span>
                        <span className="review-value">
                          {formatCurrency(depositAmount)}
                        </span>
                      </div>
                    </>
                  )}

                  {deliveryType === "pickup" && (
                    <div className="review-item">
                      <span className="review-label">{t.step3.amountPaid}</span>
                      <span className="review-value">
                        {formatCurrency(depositAmount)}
                      </span>
                    </div>
                  )}

                  {appliedPromo && (
                    <div className="review-item">
                      <span className="review-label">{t.summary.promo}</span>
                      <span
                        className="review-value"
                        style={{ color: "#10b981", fontWeight: "700" }}
                      >
                        {appliedPromo} (-{formatCurrency(discountAmount)})
                      </span>
                    </div>
                  )}
                </div>
              </div>

              <div className="step-actions">
                <button className="back-btn" onClick={() => setStep(2)}>
                  {t.step3.backBtn}
                </button>
                <button
                  className="submit-btn"
                  onClick={handleSubmitOrder}
                  disabled={isSubmitting}
                >
                  {isSubmitting ? (
                    <>
                      <div className="spinner" />
                      {t.step3.submitting}
                    </>
                  ) : (
                    <>
                      <CheckCircle size={20} />
                      {t.step3.submitBtn}
                    </>
                  )}
                </button>
              </div>
            </div>
          )}
        </div>
      </div>

      {showSuccess && (
        <div className="success-overlay">
          <div className="success-modal">
            <div className="success-icon">
              <CheckCircle size={80} />
            </div>
            <h2>{t.success.title}</h2>
            <p>{t.success.message}</p>
          </div>
        </div>
      )}
    </div>
  );
};

export default CheckoutPage;
